// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:36:41.449Z
// Property: Raintree Apts (ID: 6767906449165622)
// Collections: 23 amenities, 4 floorplans (live), 32 photos, 75 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165622",
  "property_external_id": "zvx5v2y",
  "property_zillow_url": "https://www.zillow.com/b/raintree-apartments-wichita-ks-5Xt4CX/",
  "property_apartments_url": "https://www.apartments.com/raintree-apts-wichita-ks/zvx5v2y/",
  "property_google_business_url": "https://www.google.com/maps/place/Raintree+Apartments/data=!4m2!3m1!1s0x0:0xc475d5854b012919?sa=X&ved=2ahUKEwiVr8Wd_rySAxVknCYFHQMvOSsQ_BJ6BAg8EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "5748678932",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "raintree-apartments",
  "property_name": "Raintree Apts",
  "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/raintree/",
  "property_domain": null,
  "property_address": "777 North Silver Springs Blvd",
  "property_full_address": "777 North Silver Springs Blvd, Wichita, KS, 67212",
  "property_address_1": "777 North Silver Springs Blvd",
  "property_address_2": null,
  "property_address_city": "Wichita",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "67212",
  "property_address_country": "US",
  "property_address_county": "Sedgwick County",
  "property_neighborhood_address": "West Wichita",
  "property_address_latitude": "37.6965",
  "property_address_longitude": "-97.4228",
  "property_email": "raintree@caseusa.com",
  "property_phone": "(316) 799-0117",
  "property_call_tracking_phone": "844-752-0827",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Raintree Apts. in Wichita, Kansas, your ideal home awaits! Choose from stylish studios to spacious two-bedrooms, all featuring modern amenities. Enjoy the sun by our sparkling pool, unwind in our clubhouse, or take your furry friend to the dog park. Experience community living with planned activities and lush walking trails. Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Raintree Apartments, the premier living destination in the heart of Wichita, Kansas. Our vibrant community offers a diverse selection of thoughtfully designed floor plans, including spacious studios, cozy one-bedroom, and family-friendly two-bedroom apartments. Whether you’re seeking a stylish space for yourself or a larger area for your family, we’ve got the perfect option for you.\n\nRaintree Apartments ensures that residents enjoy a lifestyle of comfort and convenience. Dive into relaxation at our inviting pool, host friends or family at the barbecue and picnic area, or unwind in our clubhouse while taking advantage of our planned social activities. For those who work from home, our fully-equipped business center and high-speed internet access provide a productive environment.\n\nYour furry friends are also welcome here! Explore our pet play area and dog park, or take a scenic stroll along the walking and biking trails that weave through our picturesque grounds. Additional amenities like on-site maintenance, laundry facilities, and package service add to the unmatched convenience of living at Raintree.\n\nEach apartment features modern conveniences, including air conditioning, stylish appliances, generous walk-in closets, and either a cozy balcony or patio space to enjoy the outdoors from the comfort of your home.\n\nExperience the perfect blend of community and comfort at Raintree Apartments. With a prime location in Wichita, you're just moments away from everything the city has to offer. Don't wait—find your new home today! Browse our availability or schedule a personalized tour to discover all that Raintree has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-b48e-7104-aed1-5aa17c741f33.webp",
  "property_featured_image_media": {
    "alt_text": "Interior view of the apartment building's entrance lobby with a chandelier and a 'welcome' sign.",
    "public_id": "019cfb45-b48e-7104-aed1-5aa17c741f33",
    "storage_key": "property/6767906449165622/019cfb45-b48e-7104-aed1-5aa17c741f33.webp",
    "width": 2048,
    "height": 3072
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "344",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.54651162790698",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "325",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Two pets maximum per household (breed restrictions apply).",
  "property_pet_policy_description": "Two pets allowed per household with breed restrictions. Monthly pet rent is $25 per pet. One-time non‑refundable pet fee is half of first month’s rent per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://raintreeapartmentswichita.securecafe.com/onlineleasing/raintree-apts/floorplans.aspx",
  "property_resident_portal_url": "https://raintreeapartmentswichita.securecafe.com/residentservices/raintree-apts/userlogin.aspx",
  "property_apply_now_url": "https://raintreeapartmentswichita.securecafe.com/onlineleasing/raintree-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-0779-75d0-9f57-ae3a0d38ee40.webp",
  "property_primary_logo_media": {
    "alt_text": "RainTree Apartments logo.",
    "public_id": "019cfb46-0779-75d0-9f57-ae3a0d38ee40",
    "storage_key": "property/6767906449165622/019cfb46-0779-75d0-9f57-ae3a0d38ee40.webp",
    "width": 693,
    "height": 251
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-f129-76ed-a12c-787e5ede727f.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb46-f129-76ed-a12c-787e5ede727f",
    "storage_key": "property/6767906449165622/019cfb46-f129-76ed-a12c-787e5ede727f.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-0779-75d0-9f57-ae3a0d38ee40.webp",
  "property_mono_white_logo_media": {
    "alt_text": "RainTree Apartments logo.",
    "public_id": "019cfb46-0779-75d0-9f57-ae3a0d38ee40",
    "storage_key": "property/6767906449165622/019cfb46-0779-75d0-9f57-ae3a0d38ee40.webp",
    "width": 693,
    "height": 251
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb47-1824-763c-833c-f608403afff1.webp",
  "property_mono_black_logo_media": {
    "alt_text": "RainTree Apartments logo",
    "public_id": "019cfb47-1824-763c-833c-f608403afff1",
    "storage_key": "property/6767906449165622/019cfb47-1824-763c-833c-f608403afff1.webp",
    "width": 640,
    "height": 232
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#4e5147",
  "property_secondary_color": "#504942",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#c7a683",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 920",
  "property_sqft_min": "500",
  "property_sqft_max": "920",
  "property_price_range": "809 - 1189",
  "property_price_min": "809",
  "property_price_max": "1189",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/raintreekansas",
  "property_instagram_url": "https://www.instagram.com/raintreeaptswichita/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJWYBgNYnguocRGSkBS4XVdcQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/raintree-apartments-wichita-2",
  "property_tiktok_url": "https://www.tiktok.com/@raintreeapartments?_t=8lPknQhw6g6&_r=1",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Raintree Apts",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Community Today",
  "property_home_amenities_blurb": "Welcome to Raintree Apartments in Wichita, Kansas, where comfort meets convenience. Choose from a variety of thoughtfully designed floor plans—studio, one, or two-bedroom options. Enjoy resort-inspired amenities, from our refreshing pool and vibrant clubhouse to serene walking trails and a fun gameroom. Your perfect home awaits!",
  "property_home_floorplans_blurb": "At Raintree Apts. in vibrant Wichita, Kansas, our diverse floor plans cater to every lifestyle. Choose from cozy studios, spacious one-bedrooms, or family-friendly two-bedrooms. Embrace comfort and convenience—browse our available apartment homes to find the perfect setting for your next chapter! Your ideal living space awaits.",
  "property_home_gallery_blurb": "Welcome to Raintree Apartments in Wichita, Kansas, where modern floor plans meet exceptional amenities. Choose from studios to two-bedroom homes, each designed for comfort. Enjoy our sparkling pool, scenic walking trails, and vibrant community events. Picture yourself living here—your ideal lifestyle awaits!",
  "property_home_neighborhood_blurb": "At Raintree Apartments in Wichita, discover a vibrant community surrounded by nature and culture. Enjoy easy access to Sedgwick County Zoo, Exploration Place, and the Wichita Art Museum. With spacious studio, one-bedroom, and two-bedroom floor plans, your dream home awaits among local gems and enriching experiences. See what’s around!",
  "property_home_reviews_blurb": "At Raintree Apartments in Wichita, our residents thrive in a welcoming community where exceptional service shines. With a dedicated team ready to address your needs promptly, you can enjoy a peaceful life—just ask our residents who appreciate our commitment: “The staff is nice and very accommodating.” Experience comfort and care today!",
  "property_neighborhood_blurb": "Raintree Apts. immerses you in the vibrant heart of Wichita. Enjoy easy access to local gems like the Sedgwick County Zoo, Exploration Place, and the Wichita Art Museum. Surrounded by lush parks and top educational institutions, our community invites you to thrive in a dynamic, fulfilling environment. Explore your new neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Raintree Apartments in Wichita, Kansas, life unfolds with vibrant amenities—from a refreshing pool and serene lake access to a welcoming dog park and exciting gameroom. Choose from stylish floor plans, each featuring modern comforts like walk-in closets and private patios. Embrace the joy of community living today!",
  "property_applynow_blurb": "At Raintree Apartments in Wichita, Kansas, your ideal home awaits! Choose from inviting studio, one, and two-bedroom floor plans, complete with luxurious amenities. Enjoy refreshing swims in the pool, relaxing walks by the lake, or vibrant social gatherings in our clubhouse. Find your new sanctuary and lease online today!",
  "property_contactus_blurb": "At Raintree Apts. in Wichita, Kansas, we offer an array of thoughtfully designed floor plans, including studio, one-bedroom, and two-bedroom options tailored to your lifestyle. Whether seeking cozy efficiency or spacious comfort, we have the perfect fit for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Raintree Apts. in vibrant Wichita, Kansas, our diverse floor plans—including cozy studios, spacious one-bedrooms, and inviting two-bedrooms—cater to every lifestyle. Curious about our community? Dive into our FAQs page for insights and answers to your most pressing questions and make Raintree your next home!",
  "property_floorplans_blurb": "At Raintree Apts. in Wichita, Kansas, find your ideal living space tailored to your lifestyle. Choose from cozy studios, spacious one-bedroom, or accommodating two-bedroom layouts. Each floor plan is designed for comfort and convenience. Browse our available apartment homes and envision your new beginning today!",
  "property_gallery_blurb": "At Raintree Apartments in Wichita, Kansas, vibrant living meets serene comfort. Picture sun-soaked afternoons by the pool, cozy nights by your fireplace, and spontaneous gatherings in our stunning clubhouse. With diverse floor plans and exciting amenities tailored for your lifestyle, Raintree welcomes you home—imagine the life you’ve always wanted!",
  "property_interactivemap_blurb": "Experience the charm of Raintree Apartments in Wichita, Kansas. With inviting studio, one- and two-bedroom layouts, and resort-style amenities like a sparkling pool, dog park, and gameroom, you’ll find the perfect blend of comfort and convenience. Check out our interactive community map to start your journey home!",
  "property_pets_blurb": "At Raintree Apts. in Wichita, Kansas, your furry friends are cherished companions! With a maximum of two pets per home, our welcoming community features ample green spaces for play. Enjoy pet-friendly living with a nominal rent and a minimal one-time fee, ensuring a fantastic lifestyle for you and your pets.",
  "property_referafriend_blurb": "At Raintree Apts. in Wichita, Kansas, our vibrant community offers diverse floor plans to suit every lifestyle, from cozy studios to spacious two-bedrooms. Great friends make great neighbors—share your love for Raintree and refer a friend today to experience the comfort of home together!",
  "property_residentaccess_blurb": "At Raintree Apts. in Wichita, Kansas, our thoughtfully designed floor plans—studios, one, and two-bedroom options—cater to your unique lifestyle. Log in to our resident portal for seamless rent payments, maintenance requests, and all your community needs. Experience convenience and comfort today at Raintree Apts. ",
  "property_reviews_blurb": "At Raintree Apartments in Wichita, residents rave about our stellar staff and quick maintenance. One satisfied tenant notes, \"The staff is nice and very accommodating to all of your needs.\" With a beautiful community atmosphere and well-kept facilities, it’s easy to see why so many call Raintree home!",
  "property_created_at": "1753982390255",
  "property_scheduletour_blurb": "At Raintree Apts. in vibrant Wichita, Kansas, choose the perfect floor plan for your lifestyle—be it a cozy studio, a spacious one-bedroom, or a charming two-bedroom. Experience community living like never before! Schedule a tour today and hear firsthand from our delighted residents about their Raintree experience.",
  "property_thankyou_blurb": "Thank you for reaching out to Raintree Apts. in vibrant Wichita, Kansas! Whether you're seeking a cozy studio, a spacious one-bedroom, or a comfortable two-bedroom, our diverse floor plans cater to your lifestyle needs. A team member will be in touch soon to assist you further.",
  "property_virtualtours_blurb": "Experience the blend of comfort and convenience at Raintree Apts. in Wichita, Kansas. With thoughtfully designed studio, one-bedroom, and two-bedroom floor plans, there's an ideal space waiting for you. Dive into our virtual tour and visualize your new home today—your perfect lifestyle awaits!",
  "property_copyright": "2025 All Rights Reserved. Raintree Apts.",
  "property_seo_title_home": "Raintree Apts. |  Apartments in Wichita, Kansas",
  "property_seo_description_home": "Experience modern living at Raintree Apts. in Wichita! From spacious layouts to vibrant amenities like a pool and dog park, your perfect home awaits. Join us!",
  "property_seo_title_floorplans": "Floor Plans | Wichita, Kansas Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Raintree Apts. in Wichita, KS! Choose from stylish studios, cozy one-bedrooms, or spacious two-bedrooms. Browse floor plans today!",
  "property_seo_title_amenities": "Amenities | Wichita, Kansas Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Raintree Apts. in Wichita! Enjoy our inviting pool, pet-friendly spaces, and modern amenities designed for your lifestyle. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in Wichita, Kansas",
  "property_seo_description_gallery": "Step into Raintree Apts. in Wichita, KS—where stunning floor plans meet vibrant amenities. Picture your life by the lake with all the comforts of home!",
  "property_seo_title_virtualtours": "Virtual Tours | Raintree Apts. Apartments",
  "property_seo_description_virtualtours": "Step into Raintree Apts. in Wichita! Take a virtual tour of our charming studio, one, and two-bedroom homes—your perfect retreat awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Raintree Apts. Apartments",
  "property_seo_description_interactivemap": "Find your perfect fit at Raintree Apts. in Wichita! Use our interactive map to explore studio to two-bedroom layouts and discover your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wichita, Kansas",
  "property_seo_description_neighborhood": "Experience the vibrant Wichita lifestyle at Raintree Apts. Uncover local gems, parks, and eateries just steps from your studio, one, or two-bedroom home!",
  "property_seo_title_contact": "Contact Us | Raintree Apts.",
  "property_seo_description_contact": "Connect with Raintree Apts. in Wichita, KS! Our leasing team is ready to help you find your perfect studio, one, or two-bedroom home. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Wichita, Kansas",
  "property_seo_description_faqs": "Find answers to your questions about Raintree Apts. in Wichita, KS! Explore our community amenities and discover your perfect apartment today.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wichita, Kansas",
  "property_seo_description_reviews": "Read real resident reviews of Raintree Apts. in Wichita, KS. Find out why life here—with pools, pet parks, and top-notch amenities—feels like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Wichita, Kansas",
  "property_seo_description_applynow": "Uncover your ideal living space at Raintree Apts. in Wichita! Choose from stylish studios & 1-2 bedroom homes, with top-notch amenities just a click away.",
  "property_seo_title_residentaccess": "Resident Access | Raintree Apts.",
  "property_seo_description_residentaccess": "Access your Raintree Apts. resident portal for easy rent payments, maintenance requests, and community updates—all at your fingertips in Wichita, Kansas!",
  "property_seo_title_referafriend": "Refer A Friend | Raintree Apts.",
  "property_seo_description_referafriend": "Refer a friend to Raintree Apts in Wichita, KS! Great friends make great neighbors—share the joy of our vibrant community and enjoy special rewards today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Raintree Apts.",
  "property_seo_description_scheduletour": "Step into Raintree Apts. in Wichita, KS, where comfort meets charm. See your future home—schedule a tour today and embrace a vibrant lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | Raintree Apts.",
  "property_seo_description_privacy": "Your privacy matters at Raintree Apts in Wichita. Learn how we protect your information and ensure a secure living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Raintree Apts.",
  "property_seo_description_accessibility": "At Raintree Apts. in Wichita, we champion accessibility for everyone. Join our commitment to digital inclusion and discover a welcoming community for all!",
  "property_seo_title_sitemap": "Sitemap | Raintree Apts.",
  "property_seo_description_sitemap": "Uncover all that Raintree Apts. in Wichita has to offer! Check out our sitemap for easy access to amenities, floor plans, and community highlights.",
  "property_seo_title_thankyou": "Thank You | Raintree Apts.",
  "property_seo_description_thankyou": "Thanks for reaching out! Your inquiry is important to us. A Raintree Apts. team member will connect with you soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Wichita, Kansas",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865653792",
  "amenities": [
    {
      "id": "ec_637b38ef17858aca7351f26e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127397021",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f0534a0f243984a2d376962",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127397023",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c7d7a42b4574e888eccf4dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127397025",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_482cc3811b63947fe42bf2bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127397026",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7ab1f8216035aee40b3df56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127397028",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8f85835e079f7e4d438f05a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127397029",
      "title": "Game Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fac39dd39e78ca5dc118f307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127397031",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16b5334c09996bb28a30401c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127397032",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3ca189f90ca2431ea69991b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127397033",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5153f0f5d00491d93192e4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "128042516",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37edb65ce383b70d2c74273e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127397034",
      "title": "Outdoor Grilling Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a75ea78ebe6d97a04c8f9f58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "128017286",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_045c3db4cc5112cafc956177",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398492",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4ef5822a5d35c28e425357a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398493",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4f79cb8b627241b9b6b4ac1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398494",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a572e5a1db74b9c11a729642",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398495",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7462a34c40cdbe166e3990ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398496",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_082b38baf4eddbb40265cb1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398497",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c4d5c22d43a3a4d9518ed4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398498",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ab9b3e78992649a352e8627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398499",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60bb0510fc00a22ba54f3af6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398500",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28ac70c4727b05930ac8ab4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398501",
      "title": "View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8138ac56fe1c8d8ffc298e74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "yardi",
      "external_id": "127398502",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_be16006a-689c-4eb6-af99-c308e6820694",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-2183-75ad-bc18-e7dcd10dd88e.webp",
      "image_media": {
        "alt_text": "A room with a carpeted floor and a chandelier hanging from the ceiling.",
        "public_id": "019d07dc-2183-75ad-bc18-e7dcd10dd88e",
        "storage_key": "property/6767906449165622/019d07dc-2183-75ad-bc18-e7dcd10dd88e.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "Step into the welcoming lobby, featuring a grand chandelier, decorative artwork, and ample natural light from large windows, creating a comfortable and inviting atmosphere.",
      "link": "",
      "alt_text": "A room with a carpeted floor and a chandelier hanging from the ceiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301332%20(1).JPG"
    },
    {
      "id": "custom_ee0924e5-ee23-4701-b4ed-73640cb26e4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-b430-779c-ac2a-e71e2f31475e.webp",
      "image_media": {
        "alt_text": "A house with a green lawn and trees in front.",
        "public_id": "019cfb45-b430-779c-ac2a-e71e2f31475e",
        "storage_key": "property/6767906449165622/019cfb45-b430-779c-ac2a-e71e2f31475e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Discover the welcoming charm of our community's main building, featuring a beautiful exterior and well-maintained grounds.",
      "link": "",
      "alt_text": "A house with a green lawn and trees in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301307%20(5).JPG"
    },
    {
      "id": "custom_4b19c48d-7a13-45b0-ba0b-ed91b534d070",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-216d-7521-be78-4df62d75ec9d.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019d07dc-216d-7521-be78-4df62d75ec9d",
        "storage_key": "property/6767906449165622/019d07dc-216d-7521-be78-4df62d75ec9d.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a wooden vanity with a sink, a toilet, and a bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301732%20(1).JPG"
    },
    {
      "id": "custom_ab3e176a-9e5a-4908-88df-bf53bca4f5c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-207b-753d-9424-df9c418134ec.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and seating.",
        "public_id": "019d07dc-207b-753d-9424-df9c418134ec",
        "storage_key": "property/6767906449165622/019d07dc-207b-753d-9424-df9c418134ec.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility obstacles and seating for residents and their furry companions.",
      "link": "",
      "alt_text": "Dog park with agility equipment and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301242.JPG"
    },
    {
      "id": "custom_2e1ca440-ce14-41ed-8dd6-3e3019fe5b83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-2287-707b-a19d-af610ed96070.webp",
      "image_media": {
        "alt_text": "Swimming pool area with lounge chairs and tables next to apartment buildings.",
        "public_id": "019d07dc-2287-707b-a19d-af610ed96070",
        "storage_key": "property/6767906449165622/019d07dc-2287-707b-a19d-af610ed96070.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and scenic views. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Swimming pool area with lounge chairs and tables next to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301751(1).JPG"
    },
    {
      "id": "custom_ec1cecbb-047e-4116-a150-0758034d2435",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-2d30-7766-9006-8d7310149554.webp",
      "image_media": {
        "alt_text": "A staged living room and bedroom area with a gray sofa, white armchair, and a bed.",
        "public_id": "019d07dc-2d30-7766-9006-8d7310149554",
        "storage_key": "property/6767906449165622/019d07dc-2d30-7766-9006-8d7310149554.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Tour this inviting living room and bedroom space, featuring a comfortable gray sofa, plush armchair, and a neatly made bed, perfect for relaxation.",
      "link": "",
      "alt_text": "A staged living room and bedroom area with a gray sofa, white armchair, and a bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301672%20(2).JPG"
    },
    {
      "id": "custom_6f7ddbc1-c575-4c67-97ff-54bd97f0ba90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-bc54-73ce-85c0-717abd7504a7.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white appliances, and a sink.",
        "public_id": "019cfb45-bc54-73ce-85c0-717abd7504a7",
        "storage_key": "property/6767906449165622/019cfb45-bc54-73ce-85c0-717abd7504a7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Compact kitchen featuring wooden cabinets, a white refrigerator, oven, sink, and dishwasher, perfect for efficient living.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, white appliances, and a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301702%20(1).JPG"
    },
    {
      "id": "custom_f05b92ef-ff15-4096-9152-f9955a7d3b12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-2f0a-74ab-b8dc-75e9253a84b0.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances, and light-colored countertops.",
        "public_id": "019d07dc-2f0a-74ab-b8dc-75e9253a84b0",
        "storage_key": "property/6767906449165622/019d07dc-2f0a-74ab-b8dc-75e9253a84b0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring ample wood cabinetry, modern white appliances including a refrigerator and oven, and light-colored countertops. The layout provides efficient workspace and storage.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white appliances, and light-colored countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301507%20(2).JPG"
    },
    {
      "id": "custom_27d94245-ff9c-4c44-9bce-5f25df5af3ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-30f2-741e-8ef3-f57bb6710381.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, sink, shower, and vanity.",
        "public_id": "019d07dc-30f2-741e-8ef3-f57bb6710381",
        "storage_key": "property/6767906449165622/019d07dc-30f2-741e-8ef3-f57bb6710381.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, sink, vanity, and shower with a decorative curtain.",
      "link": "",
      "alt_text": "Bathroom with toilet, sink, shower, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301552%20(1).JPG"
    },
    {
      "id": "custom_a60157a6-0b6f-4203-b1d3-1973e1ef3b84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-b3a7-7123-a1e9-d661870a6752.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, wooden headboard, decorative pillows, and wall art.",
        "public_id": "019cfb45-b3a7-7123-a1e9-d661870a6752",
        "storage_key": "property/6767906449165622/019cfb45-b3a7-7123-a1e9-d661870a6752.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed with plush bedding, a stylish wooden headboard, and elegant wall decor, creating a serene retreat.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, wooden headboard, decorative pillows, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301712%20(2).JPG"
    },
    {
      "id": "custom_855910e9-3746-456d-bded-97bdae72fe40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-32f9-745f-bc0b-f42edc01765b.webp",
      "image_media": {
        "alt_text": "Dining area adjacent to kitchen with a wooden table and chairs, set for a meal.",
        "public_id": "019d07dc-32f9-745f-bc0b-f42edc01765b",
        "storage_key": "property/6767906449165622/019d07dc-32f9-745f-bc0b-f42edc01765b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in your bright dining area, which seamlessly connects to your fully equipped kitchen. Perfect for entertaining or casual dining.",
      "link": "",
      "alt_text": "Dining area adjacent to kitchen with a wooden table and chairs, set for a meal.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301577%20(1).JPG"
    },
    {
      "id": "custom_60055f49-17d0-437c-8f49-7eb9b7ae72ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-c1ee-7419-9dab-1e9d5ecab06d.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and two chairs, adjacent to a sliding glass door.",
        "public_id": "019cfb45-c1ee-7419-9dab-1e9d5ecab06d",
        "storage_key": "property/6767906449165622/019cfb45-c1ee-7419-9dab-1e9d5ecab06d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy dining area featuring a round table set for two, perfect for intimate meals. The space is bright and airy, with natural light streaming through the sliding glass door.",
      "link": "",
      "alt_text": "Dining area with a round table and two chairs, adjacent to a sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301677%20(1).JPG"
    },
    {
      "id": "custom_675f65a8-55a4-4340-9f2f-875c7273296b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-3b0a-7652-bd82-ab4e25f00931.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, armchair, coffee table, and large windows.",
        "public_id": "019d07dc-3b0a-7652-bd82-ab4e25f00931",
        "storage_key": "property/6767906449165622/019d07dc-3b0a-7652-bd82-ab4e25f00931.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, comfortable seating, and large windows that let in natural light. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, armchair, coffee table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301342%20(1).JPG"
    },
    {
      "id": "custom_abf5c995-b69c-4ef5-9c78-16a64dd2b78b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-c6b1-74f9-b971-6952e1decf2e.webp",
      "image_media": {
        "alt_text": "A sign that says Rainier Estates in front of a house.",
        "public_id": "019cfb45-c6b1-74f9-b971-6952e1decf2e",
        "storage_key": "property/6767906449165622/019cfb45-c6b1-74f9-b971-6952e1decf2e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Raintree Apartments. Our community offers a beautiful and welcoming environment for all residents. Come see what makes us special.",
      "link": "",
      "alt_text": "A sign that says Rainier Estates in front of a house.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301297%20(1).JPG"
    },
    {
      "id": "custom_1c9f82c9-9e0f-4d18-ab39-7857985400a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-c695-70c6-a86b-e89fbaa8d6c1.webp",
      "image_media": {
        "alt_text": "Bathroom with a shower curtain featuring a bird print, a white toilet, and a wooden vanity with a white countertop.",
        "public_id": "019cfb45-c695-70c6-a86b-e89fbaa8d6c1",
        "storage_key": "property/6767906449165622/019cfb45-c695-70c6-a86b-e89fbaa8d6c1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Clean and functional bathroom featuring a charming bird-themed shower curtain, a white toilet, and a wooden vanity. Perfect for your daily routine.",
      "link": "",
      "alt_text": "Bathroom with a shower curtain featuring a bird print, a white toilet, and a wooden vanity with a white countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301477%20(1).JPG"
    },
    {
      "id": "custom_2eae70df-bf61-409d-8b1a-829a27a9d373",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-3f39-7509-8cfb-077a564d0d28.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelving and a basket.",
        "public_id": "019d07dc-3f39-7509-8cfb-077a564d0d28",
        "storage_key": "property/6767906449165622/019d07dc-3f39-7509-8cfb-077a564d0d28.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and a decorative basket, perfect for storage in your new apartment home.",
      "link": "",
      "alt_text": "Walk-in closet with shelving and a basket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301727%20(1).JPG"
    },
    {
      "id": "custom_ffdfe042-0beb-43bb-aa09-57f83d57d4fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-ca5e-7239-9149-37ac76982306.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a sofa, armchair, and dining table.",
        "public_id": "019cfb45-ca5e-7239-9149-37ac76982306",
        "storage_key": "property/6767906449165622/019cfb45-ca5e-7239-9149-37ac76982306.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with comfortable seating and a dining table, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with a sofa, armchair, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301657%20(1).JPG"
    },
    {
      "id": "custom_77ccd760-1d53-4581-89dd-dd87490635d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-cc3c-742f-baa9-4970e8d67baa.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with counter seating and a chalk board that says \"There's no place like home.\"",
        "public_id": "019cfb45-cc3c-742f-baa9-4970e8d67baa",
        "storage_key": "property/6767906449165622/019cfb45-cc3c-742f-baa9-4970e8d67baa.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy kitchen and dining area featuring a breakfast bar with stools, ample cabinet space, and a decorative chalkboard sign. Perfect for enjoying meals or casual gatherings.",
      "link": "",
      "alt_text": "Kitchen and dining area with counter seating and a chalk board that says \"There's no place like home.\"",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301502%20(1).JPG"
    },
    {
      "id": "custom_d6b0dcb0-ecc7-4cbe-9567-29ca9f47313a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-cd89-7127-be8c-81da28d0a122.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment with a staircase, living area, and hallway.",
        "public_id": "019cfb45-cd89-7127-be8c-81da28d0a122",
        "storage_key": "property/6767906449165622/019cfb45-cd89-7127-be8c-81da28d0a122.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment, featuring a well-appointed living area, a cozy hallway, and a charming staircase. Enjoy the comfortable and stylish living spaces.",
      "link": "",
      "alt_text": "Interior view of an apartment with a staircase, living area, and hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301447%20(1).JPG"
    },
    {
      "id": "custom_cbf74258-1588-4633-b2a4-50fc4bc85ee9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-d147-71e8-80bd-9d32022883cb.webp",
      "image_media": {
        "alt_text": "Living room with a tufted sofa, armchair, and coffee table.",
        "public_id": "019cfb45-d147-71e8-80bd-9d32022883cb",
        "storage_key": "property/6767906449165622/019cfb45-d147-71e8-80bd-9d32022883cb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a tufted sofa, accent armchair, and a round coffee table, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with a tufted sofa, armchair, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301487%20(2).JPG"
    },
    {
      "id": "custom_62f90958-ef94-4577-a81e-fa502d1d1a3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-d1f6-75bc-943a-abb9439ae94b.webp",
      "image_media": {
        "alt_text": "A living room with a couch, coffee table, and lamp.",
        "public_id": "019cfb45-d1f6-75bc-943a-abb9439ae94b",
        "storage_key": "property/6767906449165622/019cfb45-d1f6-75bc-943a-abb9439ae94b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish living and dining area featuring comfortable seating, a modern coffee table, and a dedicated dining space.",
      "link": "",
      "alt_text": "A living room with a couch, coffee table, and lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301562%20(1).JPG"
    },
    {
      "id": "custom_7358ef75-76be-4ed8-807d-b4905db5b180",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-4493-7119-b075-ca28b9335d60.webp",
      "image_media": {
        "alt_text": "Empty closet with shelving and a laundry basket.",
        "public_id": "019d07dc-4493-7119-b075-ca28b9335d60",
        "storage_key": "property/6767906449165622/019d07dc-4493-7119-b075-ca28b9335d60.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and a decorative laundry basket, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty closet with shelving and a laundry basket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301547%20(1).JPG"
    },
    {
      "id": "custom_4d881092-e543-43a1-ba02-4c71171b8819",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-d3ba-719c-aa79-990c84490147.webp",
      "image_media": {
        "alt_text": "Cozy bedroom featuring a queen-size bed with a red and white patterned comforter, bedside table with lamp, and a 'hello' wall art.",
        "public_id": "019cfb45-d3ba-719c-aa79-990c84490147",
        "storage_key": "property/6767906449165622/019cfb45-d3ba-719c-aa79-990c84490147.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this charming bedroom, complete with a comfortable queen bed, decorative accents, and ample natural light.",
      "link": "",
      "alt_text": "Cozy bedroom featuring a queen-size bed with a red and white patterned comforter, bedside table with lamp, and a 'hello' wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301532%20(1).JPG"
    },
    {
      "id": "custom_7c821f76-c841-42c6-a87b-1f0be8123a86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-4739-716c-a71f-f5cb3f15885c.webp",
      "image_media": {
        "alt_text": "Queen bed with wooden frame, nightstand with lamp, and window with blinds.",
        "public_id": "019d07dc-4739-716c-a71f-f5cb3f15885c",
        "storage_key": "property/6767906449165622/019d07dc-4739-716c-a71f-f5cb3f15885c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed, a stylish wooden nightstand with a decorative lamp, and a window offering natural light.",
      "link": "",
      "alt_text": "Queen bed with wooden frame, nightstand with lamp, and window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301457%20(2).JPG"
    },
    {
      "id": "custom_8fa3d90a-703b-40b1-9982-f50f78fbf945",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-483a-774d-81f5-4b780343f1cf.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, coffee table, and a media console.",
        "public_id": "019d07dc-483a-774d-81f5-4b780343f1cf",
        "storage_key": "property/6767906449165622/019d07dc-483a-774d-81f5-4b780343f1cf.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable gray sofa, a wooden coffee table, and a stylish media console with decorative items. Natural light streams in from the patio door.",
      "link": "",
      "alt_text": "Living room with a gray sofa, coffee table, and a media console.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301572%20(1).JPG"
    },
    {
      "id": "custom_ecd7b327-fe22-40e3-b87a-90b256b65903",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-4cc9-72d7-97fa-b0827e610749.webp",
      "image_media": {
        "alt_text": "A living room with a large screen television and comfortable seating.",
        "public_id": "019d07dc-4cc9-72d7-97fa-b0827e610749",
        "storage_key": "property/6767906449165622/019d07dc-4cc9-72d7-97fa-b0827e610749.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and entertainment options.",
      "link": "",
      "alt_text": "A living room with a large screen television and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301422%20(1).JPG"
    },
    {
      "id": "custom_f7730f25-22d3-4ed9-b737-2642b734830f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-db3e-70dd-b7f5-24c0186ccb4c.webp",
      "image_media": {
        "alt_text": "A bedroom with a bed, nightstand, and window.",
        "public_id": "019cfb45-db3e-70dd-b7f5-24c0186ccb4c",
        "storage_key": "property/6767906449165622/019cfb45-db3e-70dd-b7f5-24c0186ccb4c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with plush pillows, a stylish wooden dresser, and a large window with grey curtains.",
      "link": "",
      "alt_text": "A bedroom with a bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301622%20(1).JPG"
    },
    {
      "id": "custom_dfa7771f-c274-441f-9ffd-96ed7558242c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-db3e-70dd-b7f5-29a603f959ef.webp",
      "image_media": {
        "alt_text": "Community lounge area with fireplace and kitchen counter.",
        "public_id": "019cfb45-db3e-70dd-b7f5-29a603f959ef",
        "storage_key": "property/6767906449165622/019cfb45-db3e-70dd-b7f5-29a603f959ef.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Experience comfort and convenience in our vibrant community lounge, featuring a cozy fireplace and a well-equipped kitchen area perfect for gatherings.",
      "link": "",
      "alt_text": "Community lounge area with fireplace and kitchen counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301327%20(1).JPG"
    },
    {
      "id": "custom_965eb79f-a602-4425-9b1c-669562fe9ac3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-df34-706b-9acd-bee4d918f711.webp",
      "image_media": {
        "alt_text": "Modern communal kitchen and lounge area with high ceilings and large windows.",
        "public_id": "019cfb45-df34-706b-9acd-bee4d918f711",
        "storage_key": "property/6767906449165622/019cfb45-df34-706b-9acd-bee4d918f711.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the spacious and well-appointed communal kitchen and lounge area, perfect for socializing or working.",
      "link": "",
      "alt_text": "Modern communal kitchen and lounge area with high ceilings and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301372%20(1).JPG"
    },
    {
      "id": "custom_d9412e88-b953-45fa-91c8-50cbed0b6d17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-5564-778e-b36d-e9f9a4bc8a79.webp",
      "image_media": {
        "alt_text": "Laundry room with rows of washers and dryers, and a central folding table.",
        "public_id": "019d07dc-5564-778e-b36d-e9f9a4bc8a79",
        "storage_key": "property/6767906449165622/019d07dc-5564-778e-b36d-e9f9a4bc8a79.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities available for residents, featuring multiple washers and dryers, and a central table for folding.",
      "link": "",
      "alt_text": "Laundry room with rows of washers and dryers, and a central folding table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301742%20(1).JPG"
    },
    {
      "id": "custom_9cabc44b-93a8-4120-89c2-30a2f81635d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d07dc-568c-74e8-8895-fa5294007a94.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white appliances including stove and refrigerator, and a sink.",
        "public_id": "019d07dc-568c-74e8-8895-fa5294007a94",
        "storage_key": "property/6767906449165622/019d07dc-568c-74e8-8895-fa5294007a94.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A view of the apartment kitchen showcasing wooden cabinets, a white stove and refrigerator, and a double sink, complemented by decorative wall art.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, white appliances including stove and refrigerator, and a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301592%20(1).JPG"
    },
    {
      "id": "custom_6c5f82a4-ff99-4b92-a6d5-0709cf465b64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-e0c6-711f-9e50-bf73304525f6.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019cfb45-e0c6-711f-9e50-bf73304525f6",
        "storage_key": "property/6767906449165622/019cfb45-e0c6-711f-9e50-bf73304525f6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a spacious vanity, a modern toilet, and a bathtub with a classic shower curtain, perfect for everyday living.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7301642%20(1).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2639f77c-fde6-4d73-b5b4-4b9b5aa82a52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "6707 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, prime rib, and appetizers, and the food is consistently good. They highlight the fun, lively atmosphere and the generous portions of rolls and cinnamon butter. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-5f07-74ad-b26b-e6d0c0a574b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-5f07-74ad-b26b-e6d0c0a574b4",
        "storage_key": "property/6767906449165622/019cfb46-5f07-74ad-b26b-e6d0c0a574b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/kansas/wichita-west-kellogg?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10790040154516989602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "37.6720244",
      "poi_longitude": "-97.4200102",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-943-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_Fxv7nguocRoqYvOlrsvZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a4534093-309e-4fad-a1fb-c47c7bcc3d17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "HomeGrown",
      "poi_type": "Restaurants",
      "poi_address": "645 E Douglas Ave Ste 102, Wichita, KS 67202, USA",
      "poi_short_description": "Open-space eatery with a 'choose kind' motto, serving breakfast items and lunch dishes such as pancakes, waffles and French toast.",
      "poi_long_description": "People say this breakfast restaurant serves delicious biscuits and gravy, French toast, and gluten-free pancakes. They highlight the fresh, locally sourced ingredients and the affordable prices. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-2fb5-7262-bdf7-c6ca42068ac9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-2fb5-7262-bdf7-c6ca42068ac9",
        "storage_key": "property/6767906449165622/019cfb46-2fb5-7262-bdf7-c6ca42068ac9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homegrownkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10686225532294437036&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "homegrown",
      "poi_latitude": "37.6856462",
      "poi_longitude": "-97.3309449",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-247-9509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaY-BPffjuocRrJge6oAZTZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_0a67b792-132a-4699-8be1-0291cf299cd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Doo-Dah Diner",
      "poi_type": "Restaurants",
      "poi_address": "206 E Kellogg St, Wichita, KS 67202, USA",
      "poi_short_description": "Homey diner serving from-scratch American breakfast & lunch classics, from pancakes to burgers.",
      "poi_long_description": "People say this diner serves delicious banana bread French toast, biscuits and gravy, and monkey bread. They highlight the generous portions, homemade food, and fun, cozy vibe. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-2f95-701e-9b5b-f58180167016.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-2f95-701e-9b5b-f58180167016",
        "storage_key": "property/6767906449165622/019cfb46-2f95-701e-9b5b-f58180167016.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://doodahdiner.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12690445211555488726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "doo-dah-diner",
      "poi_latitude": "37.6796006",
      "poi_longitude": "-97.3364484",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13z0ke7juocR1mNS3K6EHbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_58a57ddf-a947-4a68-b356-aa55eaff9e5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "7320 W Taft St, Wichita, KS 67209, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, waffle fries, and fresh salads. They highlight the friendly staff and quick service, especially for online orders. They also like the clean facility and positive, Christian vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-5df1-70ac-bc71-bf37800503ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-5df1-70ac-bc71-bf37800503ff",
        "storage_key": "property/6767906449165622/019cfb46-5df1-70ac-bc71-bf37800503ff.webp",
        "width": 782,
        "height": 430
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ks/maple-ridge?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3878166640798646112&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.6772557",
      "poi_longitude": "-97.4268918",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-729-2697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2yIMLvhuocRYL-SLAME0jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_e6d6a59b-7e45-4149-a32a-d115dbabacef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "120 S Washington Ave, Wichita, KS 67202, USA",
      "poi_short_description": "Chain offering Mediterranean staples (shawarma, hummus and falafel) plus wines, beers and cocktails.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious chicken shawarma, hummus, and falafel. They highlight the generous portions, fair prices, and fresh, flavorful food. They also like the friendly and efficient service, and the warm, inviting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-5df2-7233-9d46-42755e8b0260.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-5df2-7233-9d46-42755e8b0260",
        "storage_key": "property/6767906449165622/019cfb46-5df2-7233-9d46-42755e8b0260.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.meddys.com/contact-us/locations/meddys-downtown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18251280396411841812&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "37.6854344",
      "poi_longitude": "-97.3261458",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-201-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZpbE6XjuocRFK0tNNKSSf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_e61c0ea5-8136-454e-a608-df4e2067861d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "8444 W McCormick Ave, Wichita, KS 67209, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products for home and garden projects. They also highlight the helpful and professional staff, and the well-stocked and clean store.\n\nOther reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-2f2b-72fc-9c15-ea8e3382d7b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-2f2b-72fc-9c15-ea8e3382d7b7",
        "storage_key": "property/6767906449165622/019cfb46-2f2b-72fc-9c15-ea8e3382d7b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/West-Wichita/KS/Wichita/67209/2205?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13722908378629795426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.6738686",
      "poi_longitude": "-97.4402648",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-773-1988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ0S0uR3euocRYu51mXaQcb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_9364e5b5-c652-42a6-86de-c9970593e169",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3660 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide selection of building supplies, hardware, patio equipment, appliances, paint, lighting, and lawn and garden decor. They also highlight the good prices, easy returns, and helpful staff.\n\nOther reviews mention the store can be difficult to navigate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-2ed6-70f8-ba9f-26a7456a576f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-2ed6-70f8-ba9f-26a7456a576f",
        "storage_key": "property/6767906449165622/019cfb46-2ed6-70f8-ba9f-26a7456a576f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3276&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4195684929713849559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "37.7497617",
      "poi_longitude": "-97.4597743",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-729-5851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp792U3Igu4cR18QNwTYROjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_66f8598e-a344-44b4-a837-adc96fcec242",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "333 S Ridge Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a great collection of plants. They also highlight the staff is helpful and easy to park.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-2e9c-7779-9428-51b0bfef67ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-2e9c-7779-9428-51b0bfef67ff",
        "storage_key": "property/6767906449165622/019cfb46-2e9c-7779-9428-51b0bfef67ff.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/KS-Wichita/0614?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-614-_-na-_-0-_-0&y_source=1_MTE4MzEwNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050313256936817436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "37.678859",
      "poi_longitude": "-97.428188",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-773-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPUZP16LguocRHEPaHJLhnuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_babc43a9-d119-41e7-8a5f-869864420142",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Thai Binh Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1530 W 21st St, Wichita, KS 67203, USA",
      "poi_short_description": "Sprawling Asian-style grocery stocking produce and cooking utensils, plus hot foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-2f2b-72fc-9c15-ed4dbcc36f9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-2f2b-72fc-9c15-ed4dbcc36f9d",
        "storage_key": "property/6767906449165622/019cfb46-2f2b-72fc-9c15-ed4dbcc36f9d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/pages/Thai-Binh-Supermarket/165438916815347",
      "poi_directions_map_url": "https://maps.google.com/?cid=12975717193484190098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thai-binh-supermarket",
      "poi_latitude": "37.723579",
      "poi_longitude": "-97.355179",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-838-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43ad-76d8-a52b-403f945f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43ad-76d8-a52b-403f945f1e93",
        "storage_key": "property/6767906449165622/019cfb46-43ad-76d8-a52b-403f945f1e93.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMceJz4vhuocRksGNBwoCE7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_d1d39042-f89e-446f-b777-e7166b0eb21c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Mi Super Mercado Baratísimo - Seneca - Wichita",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 S Seneca St, Wichita, KS 67217, USA",
      "poi_short_description": "Traditional Mexican grocery store featuring fresh produce, desserts, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-2ee5-75ee-bd14-a496d85e4cf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-2ee5-75ee-bd14-a496d85e4cf4",
        "storage_key": "property/6767906449165622/019cfb46-2ee5-75ee-bd14-a496d85e4cf4.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.elriobravokck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6659820061076927&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mi-super-mercado-baratsimo---seneca---wichita",
      "poi_latitude": "37.6493786",
      "poi_longitude": "-97.3545534",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-269-9119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43ad-76d8-a52b-403f945f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43ad-76d8-a52b-403f945f1e93",
        "storage_key": "property/6767906449165622/019cfb46-43ad-76d8-a52b-403f945f1e93.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFaCidSHnuocRvy0CMRKpFwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5ec041b4-c4ce-4d11-bc5a-ff8bbb57a3a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Wichita Public Library - Advanced Learning Library",
      "poi_type": "Education",
      "poi_address": "711 West 2nd St N, Wichita, KS 67203, USA",
      "poi_short_description": "Relaxed public library featuring books and media for kids and adults, plus play spaces, a studio and computers.",
      "poi_long_description": "People say this public library offers a wide selection of books, access to technology, and free classes and live events. They highlight the clean and quiet atmosphere, and the spacious layout with plenty of seating. They also like the helpful staff and the availability of meeting rooms.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wichitalibrary.org/Locations/Pages/advanced-learning-library.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1540515458718365609&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-public-library---advanced-learning-library",
      "poi_latitude": "37.68664890000001",
      "poi_longitude": "-97.3479505",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-261-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-439a-71b2-a0bd-629841e6efde",
        "storage_key": "property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfx2pGt7juocRqffnz6UCYRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_dc7d559d-873a-4677-9b9e-6f26d265c985",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Friends University",
      "poi_type": "Education",
      "poi_address": "2100 W Univ Ave, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.friends.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15570531106663261673&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "friends-university",
      "poi_latitude": "37.6777089",
      "poi_longitude": "-97.3666702",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-295-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-439a-71b2-a0bd-629841e6efde",
        "storage_key": "property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-zLPUThuocR6WXVmIujFdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_96708fcd-064b-4568-a690-5d7e9e433a86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Newman University",
      "poi_type": "Education",
      "poi_address": "3100 McCormick St, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-32fd-709d-bcc3-2fe024f5c56c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-32fd-709d-bcc3-2fe024f5c56c",
        "storage_key": "property/6767906449165622/019cfb46-32fd-709d-bcc3-2fe024f5c56c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.newmanu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8197001651856080544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newman-university",
      "poi_latitude": "37.673508",
      "poi_longitude": "-97.377744",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-942-4291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-439a-71b2-a0bd-629841e6efde",
        "storage_key": "property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjRoRMzHhuocRoP4ropKZwXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_28a122be-6ddb-410b-913c-f611bb58268a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Sedgwick County Zoo",
      "poi_type": "Entertainment",
      "poi_address": "5555 W Zoo Blvd, Wichita, KS 67212, USA",
      "poi_short_description": "Animals organized by continent, plus educational programs for various age groups.",
      "poi_long_description": "Visitors say this zoo offers a variety of animal experiences, including giraffe feeding, stingray cove, a train ride, and a boat ride, and they praise the well-maintained habitats and friendly staff. They also highlight the family-friendly atmosphere, affordable season passes, and numerous special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-6080-7689-bfee-9b2fa633738a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-6080-7689-bfee-9b2fa633738a",
        "storage_key": "property/6767906449165622/019cfb46-6080-7689-bfee-9b2fa633738a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://scz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11432857233417595508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedgwick-county-zoo",
      "poi_latitude": "37.717034",
      "poi_longitude": "-97.408561",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-660-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVutukTguocRdGqcdRSrqZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_fdc14d27-43f5-4aab-ad80-9c54af380fe3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Exploration Place",
      "poi_type": "Entertainment",
      "poi_address": "300 N McLean Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Exhibits, films, live shows, & hands-on science & discovery programs for kids and adults.",
      "poi_long_description": "People say this science museum offers interactive exhibits, a shark exhibit, and a dome theater. They highlight the educational and entertaining experience, and the fun, hands-on activities for kids and adults. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-32fd-709d-bcc3-3321289d3fa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-32fd-709d-bcc3-3321289d3fa0",
        "storage_key": "property/6767906449165622/019cfb46-32fd-709d-bcc3-3321289d3fa0.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "http://www.exploration.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14209503253032261092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "exploration-place",
      "poi_latitude": "37.6894665",
      "poi_longitude": "-97.3479609",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-660-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43a2-719b-96b8-724ca3d36801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43a2-719b-96b8-724ca3d36801",
        "storage_key": "property/6767906449165622/019cfb46-43a2-719b-96b8-724ca3d36801.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7tm5d7juocR5NW-Z-xLMsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d5577ce8-7888-46a6-89ff-cd9e1b2f3202",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "INTRUST Bank Arena",
      "poi_type": "Entertainment",
      "poi_address": "500 E Waterman St, Wichita, KS 67202, USA",
      "poi_short_description": "State-of-the-art entertainment complex hosting sports, concerts, ice shows & conventions.",
      "poi_long_description": "People say this arena offers a variety of events, including hockey games and concerts. They also highlight the clean and well-laid-out venue, comfortable seating, and friendly staff.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-3328-7214-a5aa-1fa62432944b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-3328-7214-a5aa-1fa62432944b",
        "storage_key": "property/6767906449165622/019cfb46-3328-7214-a5aa-1fa62432944b.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.intrustbankarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2995336029531607261&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intrust-bank-arena",
      "poi_latitude": "37.6832771",
      "poi_longitude": "-97.3320617",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-755-7328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ59VNcOvjuocR3RAptz-SkSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_5e93a7cf-7130-45d6-b3f0-fe1761609719",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Wichita Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1400 Museum Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Contemporary & historical works from a 7,000-piece permanent collection, & a hands-on area for kids.",
      "poi_long_description": "People say this art museum offers a diverse collection of paintings, photography, and sculptures, including works by local artists and children. They highlight the free admission, the beautiful and colorful entrance, and the rotating exhibits and themes. They also like the family-friendly atmosphere and the fun activities for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-3408-717c-9333-9ed313a8e5b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-3408-717c-9333-9ed313a8e5b5",
        "storage_key": "property/6767906449165622/019cfb46-3408-717c-9333-9ed313a8e5b5.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://wam.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14953396795402545430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-art-museum",
      "poi_latitude": "37.6949197",
      "poi_longitude": "-97.3559687",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43a2-719b-96b8-724ca3d36801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43a2-719b-96b8-724ca3d36801",
        "storage_key": "property/6767906449165622/019cfb46-43a2-719b-96b8-724ca3d36801.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJu0d-QWPhuocRFulurygjhc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_783a2a53-dc66-4cec-b38d-f6b1066fc267",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "8545 W Irving St, Wichita, KS 67209, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, a zip line, and a ropes course. They also highlight the clean facility and the friendly, helpful staff.\n\nOther reviews mention the height requirements can be unclear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-33f7-758d-a50b-f331b21edfba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-33f7-758d-a50b-f331b21edfba",
        "storage_key": "property/6767906449165622/019cfb46-33f7-758d-a50b-f331b21edfba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/kansas-wichita/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=7075506925871037131&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "37.6701433",
      "poi_longitude": "-97.4414467",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-281-7173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITbj0RzeuocRy_pbug9AMWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_3345132a-d8c2-41db-9cc2-6a7e06b891cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "WEST YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "6940 Newell St, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of classes, including yoga, and has a kid zone. They also highlight the friendly staff and welcoming, homely vibe.\n\nOther reviews mention billing issues can be difficult to resolve.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-6034-732b-b550-1479431cec0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-6034-732b-b550-1479431cec0c",
        "storage_key": "property/6767906449165622/019cfb46-6034-732b-b550-1479431cec0c.webp",
        "width": 504,
        "height": 378
      },
      "poi_business_url": "https://www.ymcawichita.org/locations/west-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=4228409214553971772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6928199",
      "poi_longitude": "-97.4231272",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-942-2271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-onBo7guocRPFx6DsdTrjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6456d869-8192-4dd4-9771-9449fcfbdcae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Richard A. DeVore SOUTH YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3405 S Meridian Ave Bldg. 1, Wichita, KS 67217, USA",
      "poi_short_description": "Fitness center offering clean facilities, exercise machines, hot tubs, and pools, plus classes.",
      "poi_long_description": "People say this gym offers a variety of equipment and classes. They also highlight the friendly staff and the convenient location.\n\nSome reviews mention the management can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-612f-71af-a7f1-7d14386d8d6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-612f-71af-a7f1-7d14386d8d6c",
        "storage_key": "property/6767906449165622/019cfb46-612f-71af-a7f1-7d14386d8d6c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ymcawichita.org/locations/richard-devore-south-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6072621654783976938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "richard-a-devore-south-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6309425",
      "poi_longitude": "-97.3764392",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-942-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fD39JLmuocR6mW-jDhJRlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bd7371fd-f6e9-4b89-b8ae-49c1277a4bd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Ken Shannon NORTHWEST Branch - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "13838 W 21st St N, Wichita, KS 67235, USA",
      "poi_short_description": "Familiar fitness club offering workout machines, classes (including swimming, yoga and Pilates), a pool and friendly staff, plus a sauna and steam room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-3443-74ca-a606-3391729011a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-3443-74ca-a606-3391729011a3",
        "storage_key": "property/6767906449165622/019cfb46-3443-74ca-a606-3391729011a3.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://ymcawichita.org/locations/ken-shannon-northwest-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6593200057211516548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ken-shannon-northwest-branch---greater-wichita-ymca",
      "poi_latitude": "37.7232046",
      "poi_longitude": "-97.5035287",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-260-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5XYsWvfuocRhHYtD4XAf1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_deebc7eb-ab0c-4c76-828e-349440aa76d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Robert D. Love Downtown YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "402 N Market St, Wichita, KS 67202, USA",
      "poi_short_description": "Nonprofit community center with an indoor track, pools, and courts for racquetball and basketball.",
      "poi_long_description": "People say this gym offers a variety of equipment, a pool, and a track. They also highlight the spacious layout, the separate saunas, and the friendly staff.\n\nOther reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-61b3-70f0-be6b-6807aa78c7a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-61b3-70f0-be6b-6807aa78c7a8",
        "storage_key": "property/6767906449165622/019cfb46-61b3-70f0-be6b-6807aa78c7a8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcawichita.org/locations/robert-d-love-downtown-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=2962762509539940888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "robert-d-love-downtown-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6924977",
      "poi_longitude": "-97.33655720000002",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-264-9374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfK39MPjuocRGBr5Fs7YHSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6be8add0-50fb-4431-86e3-c741518e2647",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Prime Time Barber Shop North Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "727 W 13th St N, Wichita, KS 67203, USA",
      "poi_short_description": "Barbershop featuring a friendly staff of skilled pros, plus kids' cuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-3471-769d-ac97-8c8ec00c191a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-3471-769d-ac97-8c8ec00c191a",
        "storage_key": "property/6767906449165622/019cfb46-3471-769d-ac97-8c8ec00c191a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://getsquire.com/booking/book/prime-time-barbershop-north-wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=13837457956166592306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "prime-time-barber-shop-north-wichita",
      "poi_latitude": "37.7076339",
      "poi_longitude": "-97.3476791",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-219-3132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcaWNiviuocRMme2d7KGCMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_d670976d-3e43-4fb4-b535-c3ba77c75a33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Veterinary Emergency & Specialty Hospital of Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "5618 W 21st St N, Wichita, KS 67205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-61b2-723a-95c4-0ff69fe75098.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-61b2-723a-95c4-0ff69fe75098",
        "storage_key": "property/6767906449165622/019cfb46-61b2-723a-95c4-0ff69fe75098.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vetwichita.com/?y_source=1_MTUyMjkzNTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9151561644725192073&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterinary-emergency--specialty-hospital-of-wichita",
      "poi_latitude": "37.7241153",
      "poi_longitude": "-97.4087979",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-262-5321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_YLl43juocRiUXvLdTgAH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_8a0d3a25-f7e0-4006-97ce-c5bdf3261c0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - West Central",
      "poi_type": "Health and Wellness",
      "poi_address": "854 N Socora St, Wichita, KS 67212, USA",
      "poi_short_description": "Gym and tennis club featuring weight machines, group classes, personal trainers, a pool, saunas and clean locker rooms.",
      "poi_long_description": "People say this gym offers personal training packages and nutrient products. They also highlight the 24-hour access.\n\nOther reviews mention the equipment can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-3877-7437-a1a0-4ed89d7c69b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-3877-7437-a1a0-4ed89d7c69b1",
        "storage_key": "property/6767906449165622/019cfb46-3877-7437-a1a0-4ed89d7c69b1.webp",
        "width": 867,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/west-central.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3017945090160134620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---west-central",
      "poi_latitude": "37.6974426",
      "poi_longitude": "-97.4363575",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-721-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQpmYNjfuocR3Amh2hHl4Sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f50a786e-0a17-4604-9022-f29a1f9b3709",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2021 N Amidon Ave, Wichita, KS 67203, USA",
      "poi_short_description": "Welcoming facility featuring strength-training equipment, cardio machines and tanning beds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-61f6-743a-983c-f8a686d55cae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-61f6-743a-983c-f8a686d55cae",
        "storage_key": "property/6767906449165622/019cfb46-61f6-743a-983c-f8a686d55cae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wichita-new-leaf-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6068367135117192520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.72080589999999",
      "poi_longitude": "-97.3649016",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-440-4808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1Ivu5HhuocRSK1Q_8ErN1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b67a3adb-a6ef-4087-bc94-76111b9c06e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Limitless Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "8635 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Barbershop offering a variety of haircuts, including fades, in a friendly setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-3932-72fe-9a79-560f871e9bbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-3932-72fe-9a79-560f871e9bbc",
        "storage_key": "property/6767906449165622/019cfb46-3932-72fe-9a79-560f871e9bbc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.limitlessbarbershop.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406037866442402230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "limitless-barbershop",
      "poi_latitude": "37.6927246",
      "poi_longitude": "-97.4428108",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-469-8087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdwzn3G_fuocRtilwGbH2YyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_c374b120-c0af-4b26-9433-c0436c57b0fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Francis",
      "poi_type": "Health and Wellness",
      "poi_address": "929 St Francis, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-6336-746b-ad46-eddbb7734721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-6336-746b-ad46-eddbb7734721",
        "storage_key": "property/6767906449165622/019cfb46-6336-746b-ad46-eddbb7734721.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-francis?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16408748786587986507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-francis",
      "poi_latitude": "37.6994424",
      "poi_longitude": "-97.3324685",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-268-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-439b-739b-b463-6bda732a2461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-439b-739b-b463-6bda732a2461",
        "storage_key": "property/6767906449165622/019cfb46-439b-739b-b463-6bda732a2461.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQufU8jjuocRS-oyiRWWt-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_699c558c-921a-4911-9fc4-9e881f85ab70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Teresa",
      "poi_type": "Health and Wellness",
      "poi_address": "14800 St Teresa St, Wichita, KS 67235, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-6363-7362-89e7-9913a9f0ddcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-6363-7362-89e7-9913a9f0ddcc",
        "storage_key": "property/6767906449165622/019cfb46-6363-7362-89e7-9913a9f0ddcc.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-teresa?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15586166186925347435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-teresa",
      "poi_latitude": "37.7257513",
      "poi_longitude": "-97.5132964",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-796-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-439b-739b-b463-6bda732a2461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-439b-739b-b463-6bda732a2461",
        "storage_key": "property/6767906449165622/019cfb46-439b-739b-b463-6bda732a2461.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVzCgkXfuocRa9LjZZEvTdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c572250c-b275-4ced-aacd-aa34e056346a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Botanica, The Wichita Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 Amidon St, Wichita, KS 67203, USA",
      "poi_short_description": "Imaginative, verdant botanical garden with children's areas, a butterfly house, events & more.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, a butterfly house, and a children's play area. They highlight the beautiful grounds, the fun and engaging activities for families, and the peaceful and tranquil atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-63e1-734f-add2-8771c7ea2566.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-63e1-734f-add2-8771c7ea2566",
        "storage_key": "property/6767906449165622/019cfb46-63e1-734f-add2-8771c7ea2566.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.botanica.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14898597451770473856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "botanica-the-wichita-gardens",
      "poi_latitude": "37.6964308",
      "poi_longitude": "-97.361781",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-264-0448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeda7xm_huocRgK1RPHJzws4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_b9a60aad-1dae-4ae7-b70a-8dcb9a82b0ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Sedgwick County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6501 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Center for outdoor sports, recreation & fitness, with fishing on 4 lakes, plus shelter rentals.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, walking and biking trails, fishing, and picnic areas. They highlight the spaciousness, beautiful scenery, and family-friendly atmosphere. They also like the well-maintained facilities and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-39d8-7112-9b33-94425f86329a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-39d8-7112-9b33-94425f86329a",
        "storage_key": "property/6767906449165622/019cfb46-39d8-7112-9b33-94425f86329a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sedgwickcounty.org/parks/sedgwick-county-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1140188679586598057&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedgwick-county-park",
      "poi_latitude": "37.7093827",
      "poi_longitude": "-97.4184872",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-660-1780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43ad-76d8-a52b-3efb43a7e4a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43ad-76d8-a52b-3efb43a7e4a6",
        "storage_key": "property/6767906449165622/019cfb46-43ad-76d8-a52b-3efb43a7e4a6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6auLGjguocRqUyuJ5DD0g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3373e4d0-c173-43bb-8cc0-fcceeeb8d9fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "O J Watson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3022 S McLean Blvd, Wichita, KS 67217, USA",
      "poi_short_description": "Popular lakefront park offers fishing, boating, 3 playgrounds, mini golf, kids' rides & concessions.",
      "poi_long_description": "Popular lakefront park offers fishing, boating, 3 playgrounds, mini golf, kids' rides & concessions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-64d7-772b-a588-5f5869de2ab5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-64d7-772b-a588-5f5869de2ab5",
        "storage_key": "property/6767906449165622/019cfb46-64d7-772b-a588-5f5869de2ab5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wichita.gov/641/OJ-Watson-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17172990704824401430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "o-j-watson-park",
      "poi_latitude": "37.6394521",
      "poi_longitude": "-97.3425931",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-529-9940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43ad-76d8-a52b-3efb43a7e4a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43ad-76d8-a52b-3efb43a7e4a6",
        "storage_key": "property/6767906449165622/019cfb46-43ad-76d8-a52b-3efb43a7e4a6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH8vteiPkuocRFr4kRA-4Uu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d0d32429-f0c0-45dc-b8cf-bcaf4d0a690d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Pawnee Prairie Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2625 S Tyler Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Spacious outdoor park with trails for walking, biking & horseback-riding, plus picnic areas.",
      "poi_long_description": "People say this park offers beautiful walking trails, a bike path, and opportunities to see wildlife. They highlight the peaceful and natural escape from the city, and the well-maintained paths suitable for various skill levels. They also like the diverse trails, including a smooth path for beginners and more moderate dirt paths. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-64ad-77f6-91d4-b128a44997e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-64ad-77f6-91d4-b128a44997e4",
        "storage_key": "property/6767906449165622/019cfb46-64ad-77f6-91d4-b128a44997e4.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Pawnee-Prairie-Park-200",
      "poi_directions_map_url": "https://maps.google.com/?cid=7082970089037678459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pawnee-prairie-park",
      "poi_latitude": "37.65121",
      "poi_longitude": "-97.4566587",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43ad-76d8-a52b-3efb43a7e4a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43ad-76d8-a52b-3efb43a7e4a6",
        "storage_key": "property/6767906449165622/019cfb46-43ad-76d8-a52b-3efb43a7e4a6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99dH-O_duocRe8fOz8TDS2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_69651824-cc52-4fb9-a7c0-29f3b8f147f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Central Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "720 Nims, Wichita, KS 67203, USA",
      "poi_short_description": "Large park featuring a miniature zoo, playgrounds, a splash pad, walking paths & picnic areas.",
      "poi_long_description": "Visitors say this city park is a great place for picnics, with plenty of trees and space to play Frisbee. They also highlight the playground and barbecue areas, making it a popular spot for families.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-3c41-7671-8762-d208dc1affba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-3c41-7671-8762-d208dc1affba",
        "storage_key": "property/6767906449165622/019cfb46-3c41-7671-8762-d208dc1affba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Central-Riverside-Park-43",
      "poi_directions_map_url": "https://maps.google.com/?cid=10285259190793395628&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "central-riverside-park",
      "poi_latitude": "37.6970794",
      "poi_longitude": "-97.3466547",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43ad-76d8-a52b-3efb43a7e4a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43ad-76d8-a52b-3efb43a7e4a6",
        "storage_key": "property/6767906449165622/019cfb46-43ad-76d8-a52b-3efb43a7e4a6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJicxOUdfjuocRrN0Pir2UvI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c6b4df35-27a4-42d1-9f0f-03bc4149707b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Wichita Dwight D. Eisenhower National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2277 Eisenhower Airport Pkwy, Wichita, KS 67209, USA",
      "poi_short_description": "Regional airport offering a host of domestic flights to & from the largest city in Kansas.",
      "poi_long_description": "Visitors say this airport is clean, easy to navigate, and has friendly staff. They also highlight its convenient rental car pickup and drop-off, quick security lines, and efficient check-in process.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-65c9-752c-b839-7ae3a63fff16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-65c9-752c-b839-7ae3a63fff16",
        "storage_key": "property/6767906449165622/019cfb46-65c9-752c-b839-7ae3a63fff16.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.flywichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8128607608438818969&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-dwight-d-eisenhower-national-airport",
      "poi_latitude": "37.6493348",
      "poi_longitude": "-97.4273195",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-946-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43a3-70cb-8187-f7aa3f440d1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43a3-70cb-8187-f7aa3f440d1b",
        "storage_key": "property/6767906449165622/019cfb46-43a3-70cb-8187-f7aa3f440d1b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0QnDVHnuocRmYiIe42dznA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_dd798fc5-1708-4526-bf32-436a789aa51d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Textron Aviation C5",
      "poi_type": "Transportation & Transit",
      "poi_address": "C5, Wichita, KS 67209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10430272576288837024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-c5",
      "poi_latitude": "37.6400806",
      "poi_longitude": "-97.4226631",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43a3-70cb-8187-f7aa3f440d1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43a3-70cb-8187-f7aa3f440d1b",
        "storage_key": "property/6767906449165622/019cfb46-43a3-70cb-8187-f7aa3f440d1b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0ZkKB0jnuocRoM0xbKXFv5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_d6179e83-d75c-4bb2-8b1e-a5eb94dd4086",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Westport Airport-71K",
      "poi_type": "Transportation & Transit",
      "poi_address": "2558 S Kessler St, Wichita, KS 67217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-65fd-7725-a06b-98bf034a15c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-65fd-7725-a06b-98bf034a15c2",
        "storage_key": "property/6767906449165622/019cfb46-65fd-7725-a06b-98bf034a15c2.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4024429820277561674&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westport-airport-71k",
      "poi_latitude": "37.6482314",
      "poi_longitude": "-97.384478",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-943-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43a3-70cb-8187-f7aa3f440d1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43a3-70cb-8187-f7aa3f440d1b",
        "storage_key": "property/6767906449165622/019cfb46-43a3-70cb-8187-f7aa3f440d1b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4S_s8TmuocRShkiZZml2Tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_105e766f-e0ae-4210-a977-6eda580a46d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "City of Wichita ​City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "455 N Main, Wichita, KS 67202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-662a-71d8-8697-bfe74d6724c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-662a-71d8-8697-bfe74d6724c9",
        "storage_key": "property/6767906449165622/019cfb46-662a-71d8-8697-bfe74d6724c9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wichita.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4707618743980993027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-wichita-city-hall",
      "poi_latitude": "37.6929601",
      "poi_longitude": "-97.339002",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-942-4482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4389-715f-99fe-7d0ac11d50a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4389-715f-99fe-7d0ac11d50a6",
        "storage_key": "property/6767906449165622/019cfb46-4389-715f-99fe-7d0ac11d50a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVI-vcTjuocRAyr1PE7SVEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_2b5bfc54-5607-4143-9e44-ea7b67072af0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Cargill Protein Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "825 E Douglas Ave, Wichita, KS 67202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-6699-77a5-9e6e-fa7bfbcf30da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-6699-77a5-9e6e-fa7bfbcf30da",
        "storage_key": "property/6767906449165622/019cfb46-6699-77a5-9e6e-fa7bfbcf30da.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cargill.com/page/cargill-protein-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=1167281867094812957&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cargill-protein-headquarters",
      "poi_latitude": "37.6853999",
      "poi_longitude": "-97.3279603",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-291-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVWVDpXjuocRHenwcKwEMxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c369b665-7635-4d15-a79f-d12b247f514b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "BG Products, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "740 S Wichita St, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-672c-76ee-aa10-b350021f6f4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-672c-76ee-aa10-b350021f6f4d",
        "storage_key": "property/6767906449165622/019cfb46-672c-76ee-aa10-b350021f6f4d.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://www.bgprod.com/?utm_source=google&utm_medium=company-profile&utm_content=website-button",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729482907961109433&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bg-products-inc",
      "poi_latitude": "37.67794190000001",
      "poi_longitude": "-97.3403841",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-961-6228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxN7feXjuocRuavp9PHIwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c38aaf30-603f-4494-8ae5-f0f0feb5ca95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Textron Aviation C6",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2655 S Hoover Rd W22, Wichita, KS 67215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-3df3-745a-a0c7-96fb33fa554c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-3df3-745a-a0c7-96fb33fa554c",
        "storage_key": "property/6767906449165622/019cfb46-3df3-745a-a0c7-96fb33fa554c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.txtav.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3817218495772905269&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-c6",
      "poi_latitude": "37.6483078",
      "poi_longitude": "-97.4184875",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-517-5755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxff2E9jnuocRNU-YVv97-TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_83743060-1219-4f48-a9fe-fc78e7995911",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Wildcat Power Gen",
      "poi_type": "Major Employers & Offices",
      "poi_address": "930 N Mosley St, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://wildcatpowergen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11235588861826930689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wildcat-power-gen",
      "poi_latitude": "37.700105",
      "poi_longitude": "-97.3273464",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 620-500-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwOMbpG3pIcRAZiHh4rU7Js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0ac759ae-bba5-4f94-a69b-df2af074030c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Wichita State University",
      "poi_type": "Education",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7912-cbc0-75be-abe4-6292abd51a4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cbc0-75be-abe4-6292abd51a4f",
        "storage_key": "property/6767906449165622/019d7912-cbc0-75be-abe4-6292abd51a4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wichita.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193094869087118587&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-state-university",
      "poi_latitude": "37.7190782",
      "poi_longitude": "-97.291526",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 316-978-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-439a-71b2-a0bd-629841e6efde",
        "storage_key": "property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSYDXm-niuocR-2Sr9ilwbx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_897a866b-7f55-451d-b7ae-a28eee69526f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Wilbur Middle School",
      "poi_type": "Education",
      "poi_address": "340 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7912-cac8-742a-8ef2-5a9dc33c18f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cac8-742a-8ef2-5a9dc33c18f3",
        "storage_key": "property/6767906449165622/019d7912-cac8-742a-8ef2-5a9dc33c18f3.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "http://wilbur.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15968973275339850066&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wilbur-middle-school",
      "poi_latitude": "37.688307",
      "poi_longitude": "-97.442531",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-973-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-439a-71b2-a0bd-629841e6efde",
        "storage_key": "property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSQPgYybeuocRUoFWMJYwnd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a50873b1-4b90-4886-9d77-33ceb1a0fde7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Wichita Northwest High School",
      "poi_type": "Education",
      "poi_address": "1220 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7912-cc7c-71fc-8a58-a875d7d0842f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cc7c-71fc-8a58-a875d7d0842f",
        "storage_key": "property/6767906449165622/019d7912-cc7c-71fc-8a58-a875d7d0842f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://northwest.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11315080650523255213&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-northwest-high-school",
      "poi_latitude": "37.70475589999999",
      "poi_longitude": "-97.440365",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-973-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-439a-71b2-a0bd-629841e6efde",
        "storage_key": "property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKdEivNXfuocRraFV2-Y9B50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_03239ad7-4b3d-4c63-bb89-8ddae4edbb39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Kensler Elementary School",
      "poi_type": "Education",
      "poi_address": "1030 N Wilbur Ln, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7912-cbae-75a9-84d2-9cd514d96462.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cbae-75a9-84d2-9cd514d96462",
        "storage_key": "property/6767906449165622/019d7912-cbae-75a9-84d2-9cd514d96462.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kensler.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6309509399426161228&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kensler-elementary-school",
      "poi_latitude": "37.7023233",
      "poi_longitude": "-97.4314923",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-973-1350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-439a-71b2-a0bd-629841e6efde",
        "storage_key": "property/6767906449165622/019cfb46-439a-71b2-a0bd-629841e6efde.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt0OcWYfguocRTNrIm17hj1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e0efefce-d5d1-4153-be59-744e5119e8ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Crummy's Sports Bar",
      "poi_type": "Restaurants",
      "poi_address": "749 N Ridge Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Informal bar for beer, bowling, trivia and karaoke, plus pizza.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7912-e589-7024-92af-6db8039a27c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e589-7024-92af-6db8039a27c3",
        "storage_key": "property/6767906449165622/019d7912-e589-7024-92af-6db8039a27c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1792458347027604428&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crummy-s-sports-bar",
      "poi_latitude": "37.695794",
      "poi_longitude": "-97.4274527",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-722-5211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-5bc7-769d-b225-000fe48ecf86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-5bc7-769d-b225-000fe48ecf86",
        "storage_key": "property/6767906449165622/019d7913-5bc7-769d-b225-000fe48ecf86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Yui9YXguocRzKNDqV4X4Bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_45804a9f-5db6-4e79-887c-713e553ff08c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Knolla's Pizza Cafe",
      "poi_type": "Restaurants",
      "poi_address": "618 S Tyler Rd, Wichita, KS 67209, USA",
      "poi_short_description": "New York- & Chicago-style pizzas, subs & beer by the pitcher in a bright, counter-serve joint.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza with good flavor and a great crust. They also highlight the friendly and helpful staff, and the clean environment.\n\nSome reviews mention that orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7912-ebbc-7615-bc9b-f7672ee7f0fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ebbc-7615-bc9b-f7672ee7f0fe",
        "storage_key": "property/6767906449165622/019d7912-ebbc-7615-bc9b-f7672ee7f0fe.webp",
        "width": 1280,
        "height": 1248
      },
      "poi_business_url": "https://knollaspizza.com/west-central/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6026280557675131004&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "knolla-s-pizza-cafe",
      "poi_latitude": "37.6728259",
      "poi_longitude": "-97.4434632",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-773-4496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO-5wdoXguocRfLARFT2moVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_5eff8d26-315c-4fd1-9660-3178b6b58b6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Barrel Boys BBQ",
      "poi_type": "Restaurants",
      "poi_address": "2202 W 13th St N, Wichita, KS 67203, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this barbecue restaurant serves delicious burnt ends, brisket, and pulled pork. They highlight the generous portions, tender meat, and flavorful sauces. They also like the friendly staff and the pleasant, family-friendly atmosphere with outdoor seating and games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7912-f7e3-7566-a27f-2f4d4cbc3c27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f7e3-7566-a27f-2f4d4cbc3c27",
        "storage_key": "property/6767906449165622/019d7912-f7e3-7566-a27f-2f4d4cbc3c27.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://barrelboysbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8637283039899652096&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barrel-boys-bbq",
      "poi_latitude": "37.7089498",
      "poi_longitude": "-97.365576",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-494-5364",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06Xfbo7huocRAJC5mSnL3Xc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_aaf6b76c-681a-4e3f-8cc4-bb60891825f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Emperor's Japanese Grill",
      "poi_type": "Restaurants",
      "poi_address": "7825 W Maple St, Wichita, KS 67209, USA",
      "poi_short_description": "Japanese steakhouse-style plates & some Chinese mains dished up in a casual establishment.",
      "poi_long_description": "Japanese steakhouse-style plates & some Chinese mains dished up in a casual establishment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7912-faff-7534-9f95-c3fa1058da24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-faff-7534-9f95-c3fa1058da24",
        "storage_key": "property/6767906449165622/019d7912-faff-7534-9f95-c3fa1058da24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://emperorsjapangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6546143461462860850&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "emperor-s-japanese-grill",
      "poi_latitude": "37.679366",
      "poi_longitude": "-97.4325794",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-260-1007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbcrHqLguocRMmQ9lcuS2Fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_58d5412a-d6e8-4efb-ac80-1bfe696eee1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Village Inn",
      "poi_type": "Restaurants",
      "poi_address": "7020 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Family-friendly chain serving homestyle American classics such as chicken-fried steak & pot pie.",
      "poi_long_description": "People say this breakfast restaurant serves delicious omelets, pancakes, and hashbrowns. They also highlight the generous portions, free pie on Wednesdays, and friendly service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7912-fa74-7381-8b87-0e199db35be5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fa74-7381-8b87-0e199db35be5",
        "storage_key": "property/6767906449165622/019d7912-fa74-7381-8b87-0e199db35be5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.villageinn.com/wichita-ks-west-central",
      "poi_directions_map_url": "https://maps.google.com/?cid=4571437177566562593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "village-inn",
      "poi_latitude": "37.6948245",
      "poi_longitude": "-97.4247636",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-945-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwVUDAo_guocRIYneeeQBcT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_d53bb9d5-a68f-4bec-b7aa-8819ad775b23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "CASA MEXICANA",
      "poi_type": "Restaurants",
      "poi_address": "6600 W Central Ave suite 200, Wichita, KS 67212, USA",
      "poi_short_description": "Mexican restaurant known for its chips and salsa, margaritas, and fajitas among other dishes.",
      "poi_long_description": "People say this Mexican restaurant serves delicious burritos, fajitas, and enchiladas, and offers great chips and salsa. They highlight the affordable prices and the authentic, home-cooked taste of the food. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7912-fbc7-72d9-bf92-b02706635e5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fbc7-72d9-bf92-b02706635e5b",
        "storage_key": "property/6767906449165622/019d7912-fbc7-72d9-bf92-b02706635e5b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://casamexicanaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14388268224535618483&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casa-mexicana",
      "poi_latitude": "37.6950556",
      "poi_longitude": "-97.4196699",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-364-3971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcgVZifhuocRs2N8yLdlrcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_a707df50-d461-43c2-ac6e-ff6931c21684",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Bionic Burger",
      "poi_type": "Restaurants",
      "poi_address": "660 N Ridge Rd #101, Wichita, KS 67212, USA",
      "poi_short_description": "Low-key fast-food joint offering a variety of burgers, plus fries, onion rings & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers and pork loin sandwiches. They also highlight the friendly staff and fast service.\n\nSome reviews mention the fries can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-01ca-72e2-b6fb-6965f2642ddb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-01ca-72e2-b6fb-6965f2642ddb",
        "storage_key": "property/6767906449165622/019d7913-01ca-72e2-b6fb-6965f2642ddb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bionic-burger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8152269197991125485&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bionic-burger",
      "poi_latitude": "37.6929667",
      "poi_longitude": "-97.4257361",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-945-3838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6z1IvI_guocR7aGem6StInE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_4436dd8f-2e33-4585-a6db-a2cb3d094359",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Subway",
      "poi_type": "Restaurants",
      "poi_address": "747 N Ridge Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_long_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-0374-77d0-93f2-2c085b7bd058.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0374-77d0-93f2-2c085b7bd058",
        "storage_key": "property/6767906449165622/019d7913-0374-77d0-93f2-2c085b7bd058.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://restaurants.subway.com/united-states/ks/wichita/747-n-ridge-road?utm_source=yxt-goog&utm_medium=local&utm_term=acq&utm_content=10703&utm_campaign=evergreen-2020&y_source=1_MTQ4OTkwNjYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14774328013391770993&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "subway",
      "poi_latitude": "37.6955871",
      "poi_longitude": "-97.4266536",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-773-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJExHxZ4_guocRcbVR6Qz1CM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_50d05395-029c-4cb8-818c-748043697737",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Nuway Burgers",
      "poi_type": "Restaurants",
      "poi_address": "7301 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Wichita-based chain known for crumbly burgers, loose-meat sandwiches and hotdogs.",
      "poi_long_description": "People say this restaurant serves great loose meat sandwiches, onion rings, and homemade root beer. They also highlight the fast and friendly service, and the retro burger joint atmosphere.\n\nOther reviews mention the food can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-0696-7782-b933-dfbd11859fc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0696-7782-b933-dfbd11859fc7",
        "storage_key": "property/6767906449165622/019d7913-0696-7782-b933-dfbd11859fc7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nuwayburgers.com/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14623147165193990171&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nuway-burgers",
      "poi_latitude": "37.69410190000001",
      "poi_longitude": "-97.4271189",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-722-2217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ50mhgY_guocRG_Clt97a78o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e799a57b-d389-43d7-8910-386bd7deb2ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Two Brothers BBQ & Sports Grill",
      "poi_type": "Restaurants",
      "poi_address": "6730 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Casual, family-owned eatery for BBQ staples such as ribs, brisket & pulled pork, plus classic sides.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, and pulled pork. They also highlight the friendly staff, great service, and the brunch buffet.\n\nOther reviews mention the food can be fatty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-0667-734c-902b-145d6dbb3f9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0667-734c-902b-145d6dbb3f9e",
        "storage_key": "property/6767906449165622/019d7913-0667-734c-902b-145d6dbb3f9e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.twobrothersbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14907278664886172780&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "two-brothers-bbq-sports-grill",
      "poi_latitude": "37.6948417",
      "poi_longitude": "-97.4216146",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-440-4077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFbOe043guocRbLxMrPZK4c4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_822272b3-acfc-465c-b8c2-b47ada7a77e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Scooter's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "7399 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_long_description": "People say this coffee shop offers delicious drinks, including sugar cookie and caramelicious coffees. They highlight the fast service and friendly staff. They also like the upbeat and welcoming vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-0be3-702b-b546-ee4e1311b087.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0be3-702b-b546-ee4e1311b087",
        "storage_key": "property/6767906449165622/019d7913-0be3-702b-b546-ee4e1311b087.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://scooterscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5018026146971935075&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scooter-s-coffee",
      "poi_latitude": "37.6941005",
      "poi_longitude": "-97.4286445",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-853-4140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-5b58-71be-a9c0-1882692771d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-5b58-71be-a9c0-1882692771d6",
        "storage_key": "property/6767906449165622/019d7913-5b58-71be-a9c0-1882692771d6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJn4ArdYXguocRY2HiqzGco0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_fc29f3d5-2979-4076-950f-7026b3318da9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "420 S Ridge Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "People say this cafe serves good sandwiches, chicken noodle soup, and salads. They also highlight the pleasant staff and the relaxed atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-0e38-72b0-9cd1-63d4ed782d4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0e38-72b0-9cd1-63d4ed782d4c",
        "storage_key": "property/6767906449165622/019d7913-0e38-72b0-9cd1-63d4ed782d4c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ks/wichita/420-south-ridge-road?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202392&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=9082280832077253352&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "37.677613",
      "poi_longitude": "-97.425596",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-247-7833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-5b58-71be-a9c0-1882692771d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-5b58-71be-a9c0-1882692771d6",
        "storage_key": "property/6767906449165622/019d7913-5b58-71be-a9c0-1882692771d6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQWpa7LzguocR6MpN-ku-Cn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_a6b6d9b1-5583-4387-903a-ffbd20101ad1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "NewMarket Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "2441 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Apparel chain supplying girls' on-trend clothing & accessories for tweens.",
      "poi_long_description": "People say this shopping center offers a great variety of stores, restaurants, and services. They also highlight the clean, well-maintained, and easy-to-navigate layout, with plenty of parking available.\n\nOther reviews mention the area can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-10a2-73de-b460-130d6155a303.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-10a2-73de-b460-130d6155a303",
        "storage_key": "property/6767906449165622/019d7913-10a2-73de-b460-130d6155a303.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.newmarketsquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=480000711702093971&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "newmarket-square",
      "poi_latitude": "37.7291358",
      "poi_longitude": "-97.4647876",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-263-3201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP7Iw4pPfuocRkyDwqBpOqQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3e5f578d-cdde-4a19-86e7-e09fc8daf3ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Plaza West Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "W Central Ave, Wichita, KS 67203, USA",
      "poi_short_description": "Shopping mall featuring a variety of stores along with a movie theater and car shows throughout the year.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-1533-7132-ac8f-b125d84ba5d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-1533-7132-ac8f-b125d84ba5d3",
        "storage_key": "property/6767906449165622/019d7913-1533-7132-ac8f-b125d84ba5d3.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10420556799518399829&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "plaza-west-shopping-center",
      "poi_latitude": "37.6934707",
      "poi_longitude": "-97.390628",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEUKij2ThuocRVV0T3TJBnZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_75020522-8974-4296-b028-c1ecc3f904c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Crossroads Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7011 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Shopping mall with a variety of businesses, including a salon, BBQ restaurant, and plasma donation center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-1419-73ec-a7ef-a2571994d0db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-1419-73ec-a7ef-a2571994d0db",
        "storage_key": "property/6767906449165622/019d7913-1419-73ec-a7ef-a2571994d0db.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17189132988518742861&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crossroads-shopping-center",
      "poi_latitude": "37.6934894",
      "poi_longitude": "-97.4238407",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-272-9344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwbcSQo7guocRTbubkWERjO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6fb24765-dfba-4928-98ce-c9c213ef7736",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Supplement World",
      "poi_type": "Shopping & Retail",
      "poi_address": "552 N Ridge Rd, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-2a26-71d9-aff1-df0c12e0479a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2a26-71d9-aff1-df0c12e0479a",
        "storage_key": "property/6767906449165622/019d7913-2a26-71d9-aff1-df0c12e0479a.webp",
        "width": 480,
        "height": 400
      },
      "poi_business_url": "http://www.supplementworldstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11660778352569803815&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "supplement-world",
      "poi_latitude": "37.6925074",
      "poi_longitude": "-97.4256309",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-201-4131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI7_lwo_guocRJ-R8VSFo06E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_ca844de1-4054-4fc3-9c33-701fedb345c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Central Heights Shopping Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "Wichita, KS 67212, USA",
      "poi_short_description": "Shopping center with a mix of stores, including discount stores, a watch shop, and a laundry.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-3ec6-774d-ac0a-cbe492f7db07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3ec6-774d-ac0a-cbe492f7db07",
        "storage_key": "property/6767906449165622/019d7913-3ec6-774d-ac0a-cbe492f7db07.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7717246416139701553&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "central-heights-shopping-mall",
      "poi_latitude": "37.6933021",
      "poi_longitude": "-97.4272689",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ0lIYYXguocRMc0pTroqGWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_45f6498b-9554-453e-a6b3-c1b491a8b287",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Ollie's Bargain Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "665 N Ridge Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Discount chain carrying a wide range of closeout merchandise, including food, housewares & toys.",
      "poi_long_description": "People say this discount store offers a wide variety of items, including books, food, fans, rugs, electronics, and car stuff. They also highlight the great deals and reasonable prices, and the friendly and helpful staff.\n\nOther reviews mention the store can be cluttered.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-367d-712e-96f2-6ef2f93de385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-367d-712e-96f2-6ef2f93de385",
        "storage_key": "property/6767906449165622/019d7913-367d-712e-96f2-6ef2f93de385.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ollies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17909287224084893754&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ollie-s-bargain-outlet",
      "poi_latitude": "37.6932408",
      "poi_longitude": "-97.4275331",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-867-3373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVZzM71bhuocROpAFxNeRivg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_725a0d79-c3b6-4790-98f3-ec9ff15a9fcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Dillons",
      "poi_type": "Shopping & Retail",
      "poi_address": "8828 W 13th St N, Wichita, KS 67212, USA",
      "poi_short_description": "Supermarket chain with mainstream grocery items, plus natural & organic foods.",
      "poi_long_description": "People say this grocery store offers a good selection of fresh food, great deals, and decent prices. They also highlight the friendly and helpful staff, and convenient locations.\n\nSome reviews mention the stores can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-2978-733c-886a-658866a105ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2978-733c-886a-658866a105ed",
        "storage_key": "property/6767906449165622/019d7913-2978-733c-886a-658866a105ed.webp",
        "width": 948,
        "height": 1280
      },
      "poi_business_url": "https://www.dillons.com/stores/grocery/ks/wichita/13th-tyler-dillons/615/00016?cid=loc_61500016_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12522967667938777193&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dillons",
      "poi_latitude": "37.7099673",
      "poi_longitude": "-97.4457532",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-722-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43ad-76d8-a52b-403f945f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43ad-76d8-a52b-403f945f1e93",
        "storage_key": "property/6767906449165622/019cfb46-43ad-76d8-a52b-403f945f1e93.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr1Zh5dDfuocRaVgxlb6Eyq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_58279e66-787e-4030-9a78-b621064a9531",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Maurices",
      "poi_type": "Shopping & Retail",
      "poi_address": "2441 N Maize Rd Suite 651, Wichita, KS 67205, USA",
      "poi_short_description": "Women's clothing chain for current fashions in a range of sizes, plus footwear & accessories.",
      "poi_long_description": "Women's clothing chain for current fashions in a range of sizes, plus footwear & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-301b-766f-91f2-ee8c70f57a19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-301b-766f-91f2-ee8c70f57a19",
        "storage_key": "property/6767906449165622/019d7913-301b-766f-91f2-ee8c70f57a19.webp",
        "width": 672,
        "height": 378
      },
      "poi_business_url": "https://locations.maurices.com/us/ks/wichita/2441-n-maize-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=10118131297701489661&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "maurices",
      "poi_latitude": "37.7276484",
      "poi_longitude": "-97.4664261",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-773-2494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK6ATg5PfuocR_WtCns7Saow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "womens_clothing_store"
    },
    {
      "id": "custom_9492c0f2-1df0-4ba9-b105-e750d19b20a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6900 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a wide variety of clothes. They also highlight the friendly and helpful staff, and the great deals with rewards and coupons.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-36db-750e-9874-0af399237163.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-36db-750e-9874-0af399237163",
        "storage_key": "property/6767906449165622/019d7913-36db-750e-9874-0af399237163.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ks/wichita-248.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16822897022719900525&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "37.6753588",
      "poi_longitude": "-97.4231881",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-942-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-8d4b7bcd4484",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-8d4b7bcd4484.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaS-Q7LvguocRbTsy7LXvduk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_25ebd24a-14b6-4e68-9ea4-ff202a7c728d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Natural Grocers",
      "poi_type": "Shopping & Retail",
      "poi_address": "10520 W 13th St N, Wichita, KS 67212, USA",
      "poi_short_description": "Retail chain focused on natural & organic groceries, supplements & household products.",
      "poi_long_description": "People say this grocery store offers a wide selection of organic produce, spices, supplements, and natural skin care products. They highlight the high-quality products and the clean, pleasant atmosphere. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-3818-71fc-bd7b-5e9d2e0c30d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3818-71fc-bd7b-5e9d2e0c30d3",
        "storage_key": "property/6767906449165622/019d7913-3818-71fc-bd7b-5e9d2e0c30d3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.naturalgrocers.com/store/wichita-maize",
      "poi_directions_map_url": "https://maps.google.com/?cid=2979795103575044303&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "natural-grocers",
      "poi_latitude": "37.7089173",
      "poi_longitude": "-97.4642459",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-721-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43ad-76d8-a52b-403f945f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43ad-76d8-a52b-403f945f1e93",
        "storage_key": "property/6767906449165622/019cfb46-43ad-76d8-a52b-403f945f1e93.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLwsNI7ffuocRz_AJ7NtbWik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_71c9155f-62e4-43a7-9d93-7f2cd8bd6b2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Great Plains Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "6232 East 29th St N #2200, Wichita, KS 67220, USA",
      "poi_short_description": "Indoor-outdoor facilities designed to educate about the flora & fauna of the Great Plains.",
      "poi_long_description": "People say this nature preserve offers beautiful walking trails, diverse wildlife, and a variety of natural environments. They highlight the peaceful and relaxing atmosphere, and the well-maintained trails with informative signage. They also like the opportunities for birdwatching and the availability of benches for observation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-41ed-74aa-a37e-9c75e72a554d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-41ed-74aa-a37e-9c75e72a554d",
        "storage_key": "property/6767906449165622/019d7913-41ed-74aa-a37e-9c75e72a554d.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://gpnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028016397833359637&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "great-plains-nature-center",
      "poi_latitude": "37.73924",
      "poi_longitude": "-97.263722",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-683-5499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43ad-76d8-a52b-3efb43a7e4a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43ad-76d8-a52b-3efb43a7e4a6",
        "storage_key": "property/6767906449165622/019cfb46-43ad-76d8-a52b-3efb43a7e4a6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcw5n0z9uocRFVH-Zv7zbt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_721b6fb9-7414-4736-b30f-ed72693d93d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Reflection Ridge Golf Course",
      "poi_type": "Entertainment",
      "poi_address": "7700 W Reflection Rd, Wichita, KS 67205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-4be6-7004-915e-5b9ea5f0d8de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4be6-7004-915e-5b9ea5f0d8de",
        "storage_key": "property/6767906449165622/019d7913-4be6-7004-915e-5b9ea5f0d8de.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://reflectionridgegolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17094841704819312163&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "reflection-ridge-golf-course",
      "poi_latitude": "37.727246",
      "poi_longitude": "-97.432121",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-721-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-5e04-7712-9feb-668cb8b0ad60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-5e04-7712-9feb-668cb8b0ad60",
        "storage_key": "property/6767906449165622/019d7913-5e04-7712-9feb-668cb8b0ad60.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJlwb5DAzguocRI8ZJS_UTPe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_30c4dcd8-61a1-480a-a5cb-95703182ca08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Bowlero Northridge",
      "poi_type": "Entertainment",
      "poi_address": "749 N Ridge Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Multioption bowling alley with late-night \"cosmic bowling\", lessons, leagues & tournaments.",
      "poi_long_description": "People say this bowling alley offers a fun experience with bowling and a variety of food options. They also highlight the friendly and helpful staff, and the attentive service.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-4e20-7200-ad68-72d249adfe5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4e20-7200-ad68-72d249adfe5e",
        "storage_key": "property/6767906449165622/019d7913-4e20-7200-ad68-72d249adfe5e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.bowlero.com/location/bowlero-northridge?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=15067080586806291478&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bowlero-northridge",
      "poi_latitude": "37.69579299999999",
      "poi_longitude": "-97.42745",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-370-9394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4393-73b2-b731-91d356e979b6",
        "storage_key": "property/6767906449165622/019cfb46-4393-73b2-b731-91d356e979b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Yui9YXguocRFuzFAvcFGdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_eb48797a-575f-49fb-9b8e-fae5fd47836c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "The Kansas African American Museum (TKAAM)",
      "poi_type": "Entertainment",
      "poi_address": "601 N Water St, Wichita, KS 67203, USA",
      "poi_short_description": "Educational museum featuring exhibits on the history and culture of African Americans in Wichita and Kansas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019d7913-4f30-71d7-8a08-33ee143db446.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4f30-71d7-8a08-33ee143db446",
        "storage_key": "property/6767906449165622/019d7913-4f30-71d7-8a08-33ee143db446.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tkaamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13544648556947136457&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-kansas-african-american-museum-tkaam",
      "poi_latitude": "37.694961",
      "poi_longitude": "-97.3397675",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-262-7651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-43a2-719b-96b8-724ca3d36801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-43a2-719b-96b8-724ca3d36801",
        "storage_key": "property/6767906449165622/019cfb46-43a2-719b-96b8-724ca3d36801.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJRaRI8XjuocRyV9XlBlC-Ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_ef63851e-1472-4618-a3fb-cf41f1028ad6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "West Acres Bowling Center",
      "poi_type": "Entertainment",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "west-acres-bowling-center",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c2e4220a-4d25-4d38-914f-61770dd07b1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "Blade & Timber",
      "poi_type": "Entertainment",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "blade-timber",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_255fa95c-28dc-4053-9467-934b3edfefdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "poi_name": "When Pigs Fly BBQ",
      "poi_type": "Restaurants",
      "poi_address": "7011 W Central Ave #116, Wichita, KS 67212, USA",
      "poi_short_description": "Family-owned, counter-serve outfit providing classic BBQ fare in a modest strip-mall space.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, and smoked turkey, along with standout sides like creamed corn, mac and cheese, and garlic green beans. They highlight the generous portions, reasonable prices, and fun weekly specials. They also like the friendly staff and fast, efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019dbbe7-82ef-771b-b1fa-a191015c9fd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe7-82ef-771b-b1fa-a191015c9fd5",
        "storage_key": "property/6767906449165622/019dbbe7-82ef-771b-b1fa-a191015c9fd5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://whenpigsflywichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17145307363348892886&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "when-pigs-fly-bbq",
      "poi_latitude": "37.6937735",
      "poi_longitude": "-97.423966",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 316-295-2150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-4385-729a-857f-16cee276897f",
        "storage_key": "property/6767906449165622/019cfb46-4385-729a-857f-16cee276897f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMXIjyo_guocR1sxMDTVe8O0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    }
  ],
  "office_hours": [
    {
      "id": "ec_1b68255ef21d001287fc8524",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e02ac1aa3f7f445da6bfac8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1d6067d6b3a1cfe498a43335",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_79bf64533dd45b8b0c13925c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_949e5b53593b1b1eaffaac90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_1006aa5c53030e510832a41a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_2e861b17-ae4b-4c31-961f-babe85dce224",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "rating": "5.0",
      "name": "Marianna Jones",
      "text": "The ladies were very wonderful to help with any questions or issues we had with the website as well as polite and professional! We have a wonderful location with a pool view and Cool breeze coming off of it in the evening.  Our apt. was very clean from the moment we walked inside with new carpet and paint.",
      "date": "2025-06-26",
      "title": ""
    },
    {
      "id": "custom_139641bc-f00e-46ac-8e57-58178b57b34d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "rating": "5.0",
      "name": "Steve Jones",
      "text": ". So far I've had a good living experience. Everybody's been real nice and helpful. Things seem to be maintained pretty well. I appreciate it when they spray for spiders as I have Arachnophobia something fierce. It was an awesome experience. The guys were great I feel a little bit safer about coming home. The only way the experience could have been better is if they would have told me how handsome I am.",
      "date": "2025-07-03",
      "title": ""
    },
    {
      "id": "custom_9f0a3650-6c7a-44dc-b42a-5d6f93a80388",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "rating": "5.0",
      "name": "Andrew Dillon",
      "text": "The lady at the front desk is super nice: I own a cleaning company and we did a move out last week for one of your tenants who had moved, I couldn’t find the building but the lady at the front desk was super sweet and assisted. Great place! 5 stars!",
      "date": "2025-07-21",
      "title": ""
    },
    {
      "id": "custom_c693090b-5c60-4564-afc5-2c97a682b248",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "rating": "5.0",
      "name": "Rawr 69",
      "text": "They did great on fixing the leaky sink. The did take a minute to get around to it. but I would contribute that to them having a maintenance for other things pre-scheduled around the same time.",
      "date": "2025-08-03",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_352c9a96-cec9-4aeb-b89d-0490afae1a37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-db48-7362-aa0f-ebbaaa9ddfa6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of the swimming pool area with lounge chairs and apartment buildings.",
        "public_id": "019cfb46-db48-7362-aa0f-ebbaaa9ddfa6",
        "storage_key": "property/6767906449165622/019cfb46-db48-7362-aa0f-ebbaaa9ddfa6.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Raintree Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=62ff9773a8d3aa60094c5bc8"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b4-cec6-71bc-9069-8ef16304033c",
      "lead_source": "LANDING_PAGE",
      "name": "case-raintree-apts-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622"
    },
    {
      "lead_collector_id": "019cf79d-3fff-7491-b8ce-91a01fcdeb15",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "raintree-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-wichita-ks",
      "search_query": "luxury apartments with in-unit laundry in Wichita, KS",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover luxury living with in-unit laundry at Raintree Apartments in Wichita, KS. Enjoy upscale amenities and the comfort of your own washer and dryer.",
      "page_copy": "Explore Raintree Apartments, where luxury meets convenience in Wichita, KS. Our spacious studio, one, and two-bedroom apartments are designed with you in mind—featuring in-unit laundry facilities unavailable in many residences. Conveniently located in West Wichita, this pet-friendly community offers a plethora of upscale amenities.\n\nEnhance your lifestyle with our sophisticated features such as ceiling fans, vinyl flooring, and a high-speed internet connection. Beyond in-unit laundry, Raintree Apartments provides residents with access to a refreshing pool, a business center, and scenic outdoor trails—perfect for relaxation and recreation. Schedule a tour today to experience why Raintree Apartments is the ideal choice for luxury living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apts with In-Unit Laundry in Wichita, KS",
      "seo_description": "Enjoy luxury living in Wichita, KS, at Raintree Apartments with in-unit laundry, upscale amenities, and a prime location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-ac-west-wichita",
      "search_query": "dog-friendly apartments with air conditioning in West Wichita",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with A/C",
      "h2_subtitle": "Experience the comfort of air-conditioned, dog-friendly living at Raintree Apartments in West Wichita. Perfect for pet lovers seeking a cool retreat.",
      "page_copy": "Welcome to Raintree Apartments, the ideal dog-friendly community located in West Wichita. Our apartment homes offer air conditioning, ensuring comfort for both you and your furry friends in all seasons. Our pet-friendly policies make it easy for you and your dog to enjoy life together, with plenty of open spaces and trails perfect for walkies.\n\nBesides the refreshing air conditioning, Raintree Apartments boast a variety of amenities designed for a modern lifestyle, including a vibrant business center and a stunning pool area. Relax in your well-designed studio, one, or two-bedroom apartment featuring stylish vinyl flooring and ceiling fans. Discover the perfect pet-friendly retreat at Raintree Apartments and schedule a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apts with A/C in West Wichita",
      "seo_description": "Discover dog-friendly apartments with air conditioning in West Wichita at Raintree, featuring modern amenities and pet-friendly policies. Book a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "apartments-pool-clubhouse-wichita-67212",
      "search_query": "apartments with a pool and clubhouse in Wichita 67212",
      "category": "Amenity",
      "h1_title": "Apts with Pool & Clubhouse in Wichita 67212",
      "h2_subtitle": "Enjoy an active lifestyle in Wichita's 67212 area with a pool and clubhouse right at your doorstep at Raintree Apartments.",
      "page_copy": "Raintree Apartments in Wichita's 67212 zip code is where community and relaxation meet. Dive into luxury with our stunning community pool, perfect for unwinding after a long day or catching some sunshine. Our inviting clubhouse is the heart of social gatherings, making it easy to connect with neighbors and create new friendships.\n\nSituated in the vibrant West Wichita neighborhood, Raintree Apartments offers more than just a place to stay—it's a lifestyle. Beyond the pool and clubhouse, residents enjoy high-speed internet access and beautifully designed units with vinyl flooring and ceiling fans. Schedule your tour today and discover why Raintree Apartments is ideal for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Pool & Clubhouse in Wichita 67212",
      "seo_description": "Find your home in Wichita 67212 with a pool & clubhouse at Raintree Apartments. Enjoy top amenities and a vibrant community. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "apartments-dishwasher-internet-wichita",
      "search_query": "apartments with dishwasher and high-speed internet access in Wichita",
      "category": "Amenity",
      "h1_title": "Apts with Dishwasher & Internet in Wichita",
      "h2_subtitle": "Raintree Apartments in Wichita provide modern living with dishwashers and high-speed internet access in all units. Enjoy convenience and connectivity at its best.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Raintree Apartments, located in the heart of Wichita. Our thoughtfully designed apartments come equipped with dishwashers, making mealtime cleanup a breeze. Coupled with high-speed internet access, you’ll stay connected whether you’re working from home or streaming your favorite shows.\n\nRaintree Apartments go beyond just practical amenities. Enjoy resort-style living with access to our inviting pool and welcoming clubhouse, perfect for relaxation and social events. Our pet-friendly community, surrounded by scenic trails, offers the ideal retreat in a convenient West Wichita location. Visit us today to see what makes Raintree Apartments stand out as a premier living choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Dishwasher & Internet in Wichita",
      "seo_description": "Live in Wichita with dishwashers & high-speed internet access at Raintree Apartments, featuring modern amenities and a vibrant community. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-west-wichita",
      "search_query": "pet-friendly apartments with dog park in West Wichita KS",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apts & Dog Park in West Wichita",
      "h2_subtitle": "Discover pet-friendly living in West Wichita, KS, featuring a dog park for you and your furry companions at Raintree Apartments.",
      "page_copy": "Raintree Apartments in West Wichita, KS, is a haven for pet lovers seeking a welcoming community. Our pet-friendly apartments provide ample space for you and your furry friends to thrive, complete with a nearby dog park where pets can run, play, and socialize. This creates a perfect environment for both outdoor fun and relaxation.\n\nExperience the best of apartment living with our top-notch amenities, including a refreshing pool, modern business center, and scenic trails for leisurely strolls. Enjoy beautifully designed spaces and thoughtful features in our studio, one, and two-bedroom layouts. Make Raintree Apartments your home, where pet friendliness meets modern comfort, and schedule a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apts & Dog Park in West Wichita, KS",
      "seo_description": "Find pet-friendly apartments with a dog park in West Wichita at Raintree. Enjoy modern amenities and a welcoming community. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "studio-apartments-west-wichita",
      "search_query": "studio apartments west wichita",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in West Wichita",
      "h2_subtitle": "Explore comfortable and modern studio apartments in West Wichita at Raintree Apartments, perfect for a streamlined lifestyle.",
      "page_copy": "Raintree Apartments offers a variety of studio apartment options in the vibrant West Wichita area. Designed with simplicity and style in mind, our studio layouts provide the perfect balance between comfort and functionality, making it easy to create a cozy home that reflects your individual taste.\n\nLocated in a lively community, Raintree Apartments provides residents with top-tier amenities such as a sparkling pool, inviting clubhouse, and scenic trails. High-speed internet access and vinyl flooring add convenience and modern touches to our homes. Embrace efficiency and charm at Raintree Apartments—come see our studio options today for a perfect West Wichita living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in West Wichita",
      "seo_description": "Find modern studio apartments in West Wichita at Raintree. Enjoy comfortable living with top amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "one-bedroom-apartment-raintree-apts",
      "search_query": "1 bedroom apartment raintree apts",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments at Raintree Apts",
      "h2_subtitle": "Discover spacious 1 bedroom apartments at Raintree Apts, offering comfort and convenience in a prime Wichita location.",
      "page_copy": "Settle into comfort with our one-bedroom apartments at Raintree Apts in Wichita. These thoughtfully designed spaces offer the perfect balance of privacy and functionality, featuring amenities like ceiling fans and modern vinyl flooring. With high-speed internet access available, staying connected and entertained is a breeze.\n\nRaintree Apts goes beyond the typical apartment experience by offering attractive community amenities. Relax by our refreshing pool, enjoy the inviting clubhouse, or take advantage of our business center. Plus, the pet-friendly environment and nearby scenic trails make it an ideal home for you and your four-legged companions. Discover your new home today at Raintree Apts, where comfort meets convenience in Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments at Raintree Apts",
      "seo_description": "Explore 1 bedroom apartments at Raintree Apts in Wichita. Enjoy spacious living with excellent amenities like a pool and high-speed internet. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-67212",
      "search_query": "2 bedroom apartments near 67212",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 67212",
      "h2_subtitle": "Find spacious 2 bedroom apartments near the 67212 area at Raintree Apartments, offering the comforts of home and community amenities.",
      "page_copy": "Located conveniently near the 67212 zip code, Raintree Apartments provides the perfect setting for those seeking a spacious two-bedroom apartment. Each unit is designed with attention to detail, offering ample living space, modern finishes such as ceiling fans and vinyl flooring, and high-speed internet access for all your connectivity needs.\n\nIn addition to a comfortable living environment, our community offers an array of exceptional amenities like a sparkling pool, a well-equipped business center, and scenic trails ideal for leisurely strolls. Pet-friendly policies cater to families with pets, making Raintree Apartments a welcoming choice for everyone. Discover the convenience of living in a vibrant community with excellent amenities, close to Wichita’s best offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apts Near 67212 at Raintree Apts",
      "seo_description": "Discover spacious 2 bedroom apartments near 67212 at Raintree Apts. Enjoy pet-friendly living with modern amenities like a pool and business center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "apartments-near-friends-university-wichita-ks",
      "search_query": "apartments near Friends University Wichita KS",
      "category": "School",
      "h1_title": "Apartments Near Friends University, Wichita",
      "h2_subtitle": "Explore Raintree Apartments, conveniently located near Friends University in Wichita, KS, offering comfort and modern amenities.",
      "page_copy": "Just a short drive from Friends University, Raintree Apartments in Wichita, KS provides the perfect home base for students and educators alike. Our apartments offer a harmonious blend of comfort and style with options that cater to a range of needs, whether you're seeking a studio, one-bedroom, or two-bedroom layout.\n\nExperience top-notch amenities, including a refreshing pool ideal for relaxation, a business center equipped for productivity, and scenic trails perfect for a leisurely escape. Raintree Apartments enhances your living experience with conveniences like high-speed internet access and pet-friendly accommodations, ensuring that you have everything you need for a rewarding lifestyle close to Friends University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Friends University, Wichita KS",
      "seo_description": "Find modern apartments near Friends University, Wichita KS at Raintree. Enjoy amenities like a pool, business center, and more. Ideal student living!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "wichita-apartments-close-to-newman-university",
      "search_query": "Wichita apartments close to Newman University",
      "category": "School",
      "h1_title": "Wichita Apartments Near Newman University",
      "h2_subtitle": "Discover student-friendly apartments at Raintree, conveniently located near Newman University in Wichita for ultimate convenience and comfort.",
      "page_copy": "Raintree Apartments offers an ideal location for those attending Newman University in Wichita. Our community is designed with students and faculty in mind, providing a variety of spacious living options including studio, one-bedroom, and two-bedroom apartments. Enjoy a seamless blend of comfort and convenience with modern amenities such as vinyl flooring, ceiling fans, and high-speed internet access.\n\nBeyond individual apartment features, Raintree boasts community perks like a relaxing pool area, an efficiently equipped business center, and scenic trails for your enjoyment. The pet-friendly environment supports a delightful living experience, making it a great choice for those with furry friends. Choose Raintree Apartments for a convenient and enjoyable lifestyle just minutes from Newman University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wichita Apartments Near Newman University",
      "seo_description": "Live near Newman University in Wichita at Raintree Apts. Spacious layouts with modern amenities like a pool and business center. Perfect for students!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "apartments-near-ascension-via-christi-st-francis-wichita",
      "search_query": "apartments near Ascension Via Christi St. Francis Wichita",
      "category": "Hospital",
      "h1_title": "Apartments Near Ascension Via Christi Wichita",
      "h2_subtitle": "Find comfortable living at Raintree Apartments, located near Ascension Via Christi St. Francis in Wichita, KS, with modern amenities and pet-friendly options.",
      "page_copy": "Raintree Apartments offers convenient living for those seeking close proximity to Ascension Via Christi St. Francis in Wichita, KS. With our thoughtfully designed studio, one-bedroom, and two-bedroom apartments, residents enjoy spacious layouts and modern conveniences tailored for comfort and ease.\n\nOur community amenities, including a sparkling pool, a business center, and high-speed internet access, ensure you have everything you need at your fingertips. For those who love the outdoors, our scenic trails offer a perfect escape. Plus, our pet-friendly policies mean your furry companions are welcomed. Choose Raintree Apartments as your serene and accessible living option near Ascension Via Christi.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Ascension Via Christi St. Francis Wichita",
      "seo_description": "Discover Raintree Apts near Ascension Via Christi St. Francis, Wichita. Enjoy modern amenities like a pool and pet-friendly spaces. Perfect for comfort and convenience!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "apartments-close-to-ascension-via-christi-st-teresa-kansas",
      "search_query": "apartments close to Ascension Via Christi St. Teresa Kansas",
      "category": "Hospital",
      "h1_title": "Apts Close to Ascension Via Christi St. Teresa",
      "h2_subtitle": "Raintree Apartments offers superb living close to Ascension Via Christi St. Teresa, Kansas, with spacious layouts and top-tier amenities.",
      "page_copy": "Situated conveniently near Ascension Via Christi St. Teresa in Wichita, KS, Raintree Apartments offers residents a comfortable retreat with easy access to essential facilities. Choose from our diverse floor plans, including studio, one-bedroom, and two-bedroom options, designed to provide a welcoming home environment.\n\nRaintree’s community features enhance your lifestyle with amenities such as a gleaming pool, well-equipped business center, and green spaces complete with scenic trails. Residents enjoy the benefit of high-speed internet access, vinyl flooring, and ceiling fans, ensuring a modern, streamlined living experience. Our pet-friendly policy further ensures that all family members feel at home at Raintree Apartments, making it an ideal choice near Ascension Via Christi St. Teresa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Ascension Via Christi St. Teresa KS",
      "seo_description": "Live near Ascension Via Christi St. Teresa, KS at Raintree Apts. Spacious living with amenities like a pool and business center in a pet-friendly community!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "apartments-near-botanica-gardens-wichita",
      "search_query": "apartments near Botanica Gardens Wichita",
      "category": "Park",
      "h1_title": "Apartments Near Botanica Gardens Wichita",
      "h2_subtitle": "Experience Raintree Apartments near Botanica Gardens in Wichita, where nature and modern living combine in a pet-friendly community.",
      "page_copy": "Discover Raintree Apartments, conveniently located near the vibrant Botanica Gardens in Wichita. Our residences provide a perfect blend of tranquility and modern convenience, offering studio, one, and two-bedroom layouts that suit various lifestyle needs. Enjoy the beauty of nature right at your doorstep while benefiting from the comforts of a well-designed living space.\n\nRaintree offers exceptional amenities, including a refreshing pool, a state-of-the-art business center, and scenic trails that are ideal for leisurely strolls. With high-speed internet access, vinyl flooring, and ceiling fans, each apartment is crafted for comfort and efficiency. Our pet-friendly community welcomes all family members, ensuring your stay at Raintree is both relaxing and convenient near the lush surroundings of Botanica Gardens.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Botanica Gardens Wichita",
      "seo_description": "Live near Botanica Gardens, Wichita at Raintree Apts. Enjoy a pet-friendly community with modern amenities like a pool and scenic trails.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "sedgwick-county-park-nearby-apartments",
      "search_query": "Sedgwick County Park nearby apartments",
      "category": "Park",
      "h1_title": "Apts Near Sedgwick County Park",
      "h2_subtitle": "Explore Raintree Apartments near Sedgwick County Park, where ample amenities and cozy homes await you in Wichita, KS.",
      "page_copy": "Raintree Apartments offers a vibrant living experience in close proximity to Sedgwick County Park in Wichita. It's an ideal spot for those who enjoy outdoor activities, with the park providing an expansive area for recreation just a short distance away. Choose from our meticulously designed studio, one-bedroom, and two-bedroom apartments that cater to diverse lifestyle preferences.\n\nOur community boasts resort-style features including a shimmering pool, a business center perfect for remote work, and scenic walking trails to relax and unwind. The apartments come equipped with modern conveniences such as high-speed internet access and ceiling fans, enhancing your day-to-day living. Raintree's pet-friendly policy means your furry friends can enjoy the welcoming environment too, making it a complete package for nature lovers and city dwellers alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Sedgwick County Park Wichita",
      "seo_description": "Find Raintree Apts nearby Sedgwick County Park in Wichita. Enjoy amenities like a pool, business center, and pet-friendly living close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "oj-watson-park-apartments-west-wichita",
      "search_query": "O J Watson Park apartments West Wichita",
      "category": "Park",
      "h1_title": "Apts Near O J Watson Park, West Wichita",
      "h2_subtitle": "Discover Raintree Apartments in West Wichita, near O J Watson Park, offering a lively community with exceptional amenities.",
      "page_copy": "Located in the heart of West Wichita, Raintree Apartments provides easy access to O J Watson Park, making it a prime choice for those seeking a balance of city life and nature. Our apartments offer diverse floor plans including studio, one, and two-bedroom options, ensuring you find the perfect fit for your lifestyle.\n\nResidents at Raintree enjoy a variety of upscale amenities such as a sparkling pool, a comprehensive business center, and tranquil walking trails. Features like high-speed internet, stylish vinyl flooring, and ceiling fans are standard, enhancing your living experience. Being a pet-friendly community, Raintree Apartments welcomes all members of your family, making it an ideal choice near the recreational attractions of O J Watson Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near O J Watson Park West Wichita",
      "seo_description": "Raintree Apts in West Wichita near O J Watson Park offer a vibrant, pet-friendly community with modern amenities. Enjoy city and nature living!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "central-riverside-park-living-kansas",
      "search_query": "Central Riverside Park living Kansas",
      "category": "Park",
      "h1_title": "Living Near Central Riverside Park KS",
      "h2_subtitle": "Experience vibrant living near Central Riverside Park at Raintree Apartments, where modern comforts and nature meet in Wichita, Kansas.",
      "page_copy": "For those who crave a lifestyle blending urban convenience with natural beauty, Raintree Apartments offers an ideal location near Central Riverside Park in Wichita, Kansas. Our community provides studio, one, and two-bedroom apartment options, perfect for diverse living needs. Enjoy easy access to the scenic vistas and abundant recreational activities available in the nearby park.\n\nAt Raintree, we ensure our residents enjoy a comfortable lifestyle with amenities like a refreshing pool, a versatile business center, and scenic trails. Our apartments are equipped with high-speed internet, vinyl flooring, and ceiling fans for modern living. The pet-friendly atmosphere at Raintree welcomes families of all kinds, making it a prime choice for those looking to experience the best of Kansas near Central Riverside Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Central Riverside Park KS",
      "seo_description": "Discover Raintree Apts near Central Riverside Park, KS. Offering pet-friendly living with modern amenities for those seeking city convenience and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165622",
      "source": "generator",
      "page_item_url": "apartments-close-to-pawnee-prairie-park-67212",
      "search_query": "apartments close to Pawnee Prairie Park 67212",
      "category": "Park",
      "h1_title": "Apts Near Pawnee Prairie Park 67212",
      "h2_subtitle": "Find comfort and convenience at Raintree Apartments, located near Pawnee Prairie Park in Wichita's 67212 area.",
      "page_copy": "Raintree Apartments offers a distinct living experience in Wichita's coveted 67212 area, just moments from the natural beauty of Pawnee Prairie Park. Whether you're drawn to the allure of studio, one-bedroom, or two-bedroom layouts, our community provides the perfect backdrop for your lifestyle. Proximity to Pawnee Prairie Park means endless opportunities for outdoor activities and relaxation.\n\nOur residents enjoy top-notch amenities, including a sparkling pool, efficient business center, and peaceful walking trails within the community. Every unit is designed with features like high-speed internet, ceiling fans, and pet-friendly spaces, ensuring comfort and convenience. Embrace the best of both worlds at Raintree Apartments, where contemporary living meets nature's tranquility near Pawnee Prairie Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, and dining area.",
        "public_id": "019cfb46-20c1-746e-a57d-82aac629ffef",
        "storage_key": "property/6767906449165622/019cfb46-20c1-746e-a57d-82aac629ffef.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Pawnee Prairie Park 67212",
      "seo_description": "Explore Raintree Apts near Pawnee Prairie Park 67212, a perfect blend of comfort and convenience with pet-friendly living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5204"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-Y2XDY8WWLC"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128852407"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/raintree/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KS648TVG"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165622/019d1bd9-6b73-742f-a58c-4e54e9cc7d05.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "5748678932"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "a14dca67-45c4-42a6-87ed-88db5c93a2d7"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-697-6754"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "650082a79244b1343c47d124"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImdsT3BkcFg0MTllRURJWHpHWHNrU0E9PSIsInZhbHVlIjoiQUNtNzZkMnVpZDExeDZHZnZVVEZrZz09IiwibWFjIjoiMzc3NGE5YWQ5NTQyN2M2N2FlMjUzZmEzNGRjNzA0MDIzZDIyMjMwNDM2YzQ3YmZlYTQ1NTUyY2RmZGQyZTQwOSJ9"
    }
  ],
  "custom_qb_id": "5204",
  "custom_ga4_id": "G-Y2XDY8WWLC",
  "custom_repli_id": "18128852407",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/raintree/register/",
  "custom_google_gtm_id": "GTM-KS648TVG",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165622/019d1bd9-6b73-742f-a58c-4e54e9cc7d05.pdf",
  "custom_hubspot_company_id": "5748678932",
  "custom_rentgrata_property_id": "a14dca67-45c4-42a6-87ed-88db5c93a2d7",
  "custom_ppc_tracking_phone_number": "844-697-6754",
  "custom_residentboost_apartment_id": "650082a79244b1343c47d124",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImdsT3BkcFg0MTllRURJWHpHWHNrU0E9PSIsInZhbHVlIjoiQUNtNzZkMnVpZDExeDZHZnZVVEZrZz09IiwibWFjIjoiMzc3NGE5YWQ5NTQyN2M2N2FlMjUzZmEzNGRjNzA0MDIzZDIyMjMwNDM2YzQ3YmZlYTQ1NTUyY2RmZGQyZTQwOSJ9"
};

export const generatedAt = '2026-08-27T21:36:41.449Z';
